<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <div>
      <div id="simple-calendar-app" class="simple-calendar-app">
        <b-card class="mb-10" v-if="this.$store.getters.roles == 'assistant'">
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:full">
              <h3>{{ $t("AppointmentsOf") }}</h3>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:full">
              <div class="the-navbar__user-meta flex items-center image-right">
                <div>
                  <vs-dropdown
                    vs-custom-content
                    vs-trigger-click
                    class="cursor-pointer image-pos"
                  >
                    <div class="con-img mr-3">
                      <img
                        key="onlineImg"
                        :src="
                          selectedStaff.profile_image
                            ? selectedStaff.profile_image.path
                            : staffImageUrl
                        "
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer"
                        @error="errorImg"
                      />
                    </div>

                    <vs-dropdown-menu
                      class="vx-navbar-dropdown"
                      style="min-width: 13rem"
                    >
                      <div>
                        <vs-dropdown-item
                          class="flex appointment-of"
                          :class="
                            selfData.id == selectedStaff.id ? 'text-blue' : ''
                          "
                          @click="setSelectedStaff(selfData)"
                        >
                          <div class="vx-row">
                            <div class="vx-col w-1/5 con-img">
                              <img
                                key="onlineImg"
                                :src="
                                  selfData.profile_image
                                    ? selfData.profile_image.path
                                    : staffImageUrl
                                "
                                alt="user-img"
                                width="40"
                                height="40"
                                class="rounded-full shadow-md cursor-pointer"
                                @error="errorImg"
                              />
                            </div>
                            <div
                              class="vx-col w-4/5"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <span class="mt-2">{{
                                selfData.first_name + " " + selfData.last_name
                              }}</span
                              ><br />
                              <span>{{ selfData.email }}</span>
                              <span class="font-semibold font-design"></span>
                            </div>
                          </div>
                        </vs-dropdown-item>
                      </div>

                      <div v-for="(staff, index) in staffList" :key="index">
                        <vs-dropdown-item
                          class="flex appointment-of"
                          :class="
                            staff.id == selectedStaff.id ? 'text-blue' : ''
                          "
                          @click="setSelectedStaff(staff)"
                        >
                          <div class="vx-row">
                            <div class="vx-col w-1/5 con-img">
                              <img
                                key="onlineImg"
                                :src="
                                  staff.profile_image
                                    ? staff.profile_image.path
                                    : staffImageUrl
                                "
                                alt="user-img"
                                width="40"
                                height="40"
                                class="rounded-full shadow-md cursor-pointer"
                                @error="errorImg"
                              />
                            </div>
                            <div
                              class="vx-col w-4/5"
                              style="
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                              "
                            >
                              <span class="mt-2">{{
                                staff.first_name + " " + staff.last_name
                              }}</span
                              ><br />
                              <span>{{ staff.email }}</span>
                              <span class="font-semibold font-design"></span>
                            </div>
                          </div>
                        </vs-dropdown-item>
                      </div>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
                <div class="mt-2 md:text-right md:text-right leading-tight">
                  <div class="mt-2">
                    {{
                      selectedStaff.first_name + " " + selectedStaff.last_name
                    }}
                  </div>
                  <div>{{ selectedStaff.email }}</div>
                  <p class="font-semibold font-design"></p>
                </div>
              </div>
            </div>
          </div>
        </b-card>

        <div class="vx-card">
          <div class="demo-app-main">
            <div slot="header" class="mb-4">
              <div class="vx-row no-gutter">
                <!--div class="vx-col w-1/5 items-center sm:flex hidden"></div-->
                <div
                  class="vx-col sm:w-1/2 w-full sm:my-0 my-3 flex mobile-flex"
                >
                  <div class="flex items-center mobile-item-center">
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                      @click="updateMonth(-1)"
                      svgClasses="w-6 h-6 m-1"
                      class="cursor-pointer"
                    />
                    <feather-icon
                      :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                      @click="updateMonth(1)"
                      svgClasses="w-6 h-6 m-1"
                      class="cursor-pointer"
                    />
                    <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{
                      showDate | showDateValue(calendarView, $i18n.locale)
                    }}</span>
                  </div>
                </div>

                <div
                  class="vx-col sm:w-1/2 w-full text-right calendar-type-list"
                >
                  <template v-for="(view, index) in calendarViewTypes">
                    <b-button
                      variant="primary"
                      v-if="calendarView === view.val"
                      :key="String(view.val) + 'filled'"
                      type="filled"
                      class="custom-calendar-button c-bg-primary"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="changeDate(view.val)"
                      >{{ $t(view.label) }}</b-button
                    >
                    <b-button
                      v-else
                      variant="outline-primary"
                      :key="String(view.val) + 'border'"
                      type="border"
                      class="custom-calendar-button"
                      :class="{
                        'border-l-0 rounded-l-none': index,
                        'rounded-r-none':
                          calendarViewTypes.length !== index + 1,
                      }"
                      @click="changeDate(view.val)"
                      >{{ $t(view.label) }}</b-button
                    >
                  </template>
                </div>
              </div>

              <div class="vx-row sm:flex hidden mt-4"></div>
            </div>
            <FullCalendar
              ref="calendar"
              v-if="calendar_status && render"
              class="demo-app-calendar"
              :config="config"
              :options="calendarOptions"
            >
              <template v-slot:eventContent="arg">
                <div v-if="calendarView == 'month' || calendarView == 'list'">
                  <div v-if="checkMonth(arg.event.start)">
                    <span :class="arg.event.classNames[0] + '-dot mr-1'"></span>
                    <span v-html="arg.event.title"></span>
                  </div>
                  <div v-else>
                    <span class="black-dot mr-1"></span>
                    <span class="text-black" v-html="arg.event.title"></span>
                  </div>
                </div>
                <div v-else>
                  <span v-html="arg.event.title"></span>
                </div>
              </template>
            </FullCalendar>
          </div>

          <!-- <calendar-view
          ref="calendar"
          :displayPeriodUom="calendarView"
          :show-date="showDate"
          :startingDayOfWeek="1"
          :events="events"
          :eventTop="windowWidth <= 100 ? '2rem' : '3rem'"
          eventBorderHeight="2px"
          eventContentHeight="1px"
          class="theme-default"
          @click-date="openAddNewEvent"
          @click-event="openAddNewEvent"
        >
          <div slot="header" class="mb-4">
            <div class="vx-row no-gutter">
              <div class="vx-col w-1/3 items-center sm:flex hidden">
              </div>
              <div
                class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last"
              >
                <div class="flex items-center">
                  <feather-icon
                    :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                    @click="updateMonth(-1)"
                    svgClasses="w-5 h-5 m-1"
                    class="cursor-pointer bg-primary text-white rounded-full"
                  />
                  <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{
                    showDate | month
                  }}</span>

                  <feather-icon
                    :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                    @click="updateMonth(1)"
                    svgClasses="w-5 h-5 m-1"
                    class="cursor-pointer bg-primary text-white rounded-full"
                  />
                </div>
              </div>

              <div class="vx-col sm:w-1/3 w-full flex justify-center">
                <template v-for="(view, index) in calendarViewTypes">
                  <vs-button
                    v-if="calendarView === view.val"
                    :key="String(view.val) + 'filled'"
                    type="filled"
                    class="p-3 md:px-8 md:py-3"
                    :class="{
                      'border-l-0 rounded-l-none': index,
                      'rounded-r-none': calendarViewTypes.length !== index + 1,
                    }"
                    @click="changeDate(view.val)"
                    >{{ $t(view.label) }}</vs-button
                  >
                  <vs-button
                    v-else
                    :key="String(view.val) + 'border'"
                    type="border"
                    class="p-3 md:px-8 md:py-3"
                    :class="{
                      'border-l-0 rounded-l-none': index,
                      'rounded-r-none': calendarViewTypes.length !== index + 1,
                    }"
                    @click="changeDate(view.val)"
                    >{{ $t(view.label) }}</vs-button
                  >
                </template>
              </div>
            </div>

            <div class="vx-row sm:flex hidden mt-4"></div>
          </div>
        </calendar-view> -->
        </div>
      </div>

      <br />

      <b-card>
        <div class="heading">
          <span class="h4">{{ $t("Appointments") }}</span>
          <button class="border-0 btn-sm btn-primary ml-5" @click="openSidebar">
            +
          </button>

          <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            v-b-modal.modal-1
          />
          <div class="flex" style="float: right">
            <b-button
              class="book"
              @click="$router.push('/company/appointment/add')"
              variant="primary"
              type="filled"
              v-if="is_unio"
              >{{ $t("Add") }}</b-button
            >
          </div>
        </div>
        <b-modal
          id="modal-1"
          :title="$t('ExportToExcel')"
          :ok-title="$t('Export')"
          :cancel-title="$t('Cancel')"
          @ok="exportToExcel"
          @cancel="clearFields"
          @close="clearFields"
          class="export-options"
          centered
        >
          <b-input
            v-model="fileName"
            :placeholder="$t('FileName')"
            class="w-full"
          />
          <v-select v-model="selectedFormat" :options="formats" class="my-4"
            ><template v-slot:option="option">
              <span :class="option.icon">{{ option.label }} </span>
              <feather-icon
                v-if="selectedFormat == option.label"
                icon="CheckIcon"
                class="float-right"
                svgClasses="w-5 h-5"
              />
            </template>
          </v-select>
          <div class="flex walk-card">
            <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
            <b-form-checkbox
              v-model="cellAutoWidth"
              size="lg"
              name="cell_width"
              switch
            >
            </b-form-checkbox>
          </div>
        </b-modal>

        <div class="vx-row">
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/4 md:w-1/4 xl:w-1/4 mt-5"
          ></div>
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/4 md:w-1/4 xl:w-1/4 mt-5"
          >
            <div class="flex walk-card">
              <b-form-checkbox
                v-model="show_rejected"
                size="lg"
                name="cell_width"
                switch
                @change="changeSwitch"
              >
              </b-form-checkbox>
              <span class="ml-4 mr-3 mt-1">{{
                $t("ShowRejectedMeeting")
              }}</span>
            </div>
          </div>
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/4 md:w-1/4 xl:w-1/4 mt-5"
          >
            <div class="flex walk-card">
              <b-form-checkbox
                v-model="show_completed"
                size="lg"
                name="cell_width"
                switch
                @change="changeSwitch"
              >
              </b-form-checkbox>
              <span class="ml-4 mt-1">{{ $t("ShowCompletedMeetings") }}</span>
            </div>
          </div>
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/4 md:w-1/4 xl:w-1/4 mt-5"
          >
            <div class="flex walk-card">
              <b-form-checkbox
                v-model="no_show"
                size="lg"
                name="cell_width"
                switch
                @change="changeSwitch"
              >
              </b-form-checkbox>
              <span class="ml-4 mt-1">{{ $t("NoShow") }}</span>
            </div>
          </div>
          <!--div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3  mt-5"
          >
            <div class="flex walk-card" >
              <b-form-checkbox
                v-model="show_canceled"
                size="lg"
                name="cell_width"
                switch
                @change="changeSwitch"
              >
              </b-form-checkbox>
              <span class="ml-4 mr-3">{{ $t("ShowCancelledMeetings") }}</span>
            </div>
          </div-->
        </div>

        <div class="export-table mt-5">
          <b-col lg="5" class="my-1 p-2 float-right">
            <b-form-group
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  :placeholder="$t('Search')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="staffs.appointment_list"
            :fields="sWidth > 768 ? fields : fieldResponsive"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            @filtered="onFiltered"
            @row-clicked="myRowClickHandler"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>
            <template #cell()="data">
              {{ data.value || "NA" }}
            </template>
            <template #cell(start_time)="data">
              {{ data.item.start_time | displayTime(is_unio) }}
            </template>
            <template #cell(end_time)="data">
              {{ data.item.end_time | displayTime(is_unio) }}
            </template>
            <template #cell(type)="data">
              <span v-if="data.item.type == 'one-to-one'">{{
                $t("OneToOne")
              }}</span>
              <span v-else-if="data.item.type == 'walkin'">{{
                $t("Walkin")
              }}</span>
              <span v-else>{{ $t("Conference") }}</span>
            </template>
            <template #cell(is_inperson)="data">
              {{
                data.item.is_inperson == 1
                  ? $t("InPersonal")
                  : $t("VideoConfereneType")
              }}
            </template>

            <template #cell(current_status)="data">
              <div
                v-if="
                  data.item.is_cancelled == 1 ||
                  staffs.reschedule_waiting_confirmation == 2
                "
              >
                {{ $t("Canceled") }}
              </div>
              <div
                v-else-if="
                  data.item.user_status == 2 || data.item.is_confirmed == 0
                "
              >
                {{ $t("Rejected") }}
              </div>
              <div v-else>
                <div v-if="data.item.current_status == 1">
                  {{ $t("Completed") }}
                </div>
                <div v-else-if="data.item.reschedule_waiting_confirmation == 0">
                  {{ $t("WaitingForConfirm") }}
                </div>
                <div v-else-if="data.item.current_status == 2">
                  {{ $t("NoShow") }}
                </div>
                <div v-else-if="data.item.reschedule_waiting_confirmation == 1">
                  {{ $t("Pending") }}
                </div>
                <div v-else>
                  {{ $t("Pending") }}
                </div>
              </div>
            </template>

            <template #cell(action)="data">
              <div>
                <div
                  id="accept"
                  v-if="
                    data.item.type != 'walkin' &&
                    data.item.is_cancelled == 0 &&
                    data.item.automatic_booking_confirmed == 0
                  "
                >
                  <feather-icon
                    v-if="
                 data.item.is_confirmed == null &&
                      (data.item.is_booked_by_inmate == 0 ||
                        (data.item.is_booked_by_inmate == 1 &&
                          data.item.user_status == 1))
                           && 
                      checkTransfer(data.item)
                    "
                    v-b-tooltip.hover
                    :title="$t('Accept')"
                    @click="acceptAppointment(data.item.id)"
                    icon="CheckIcon"
                    svgClasses="h-5 hover:text-danger stroke-current"
                  />

                  <feather-icon
                    v-if="
                       data.item.is_confirmed == null &&
                      (data.item.is_booked_by_inmate == 0 ||
                        (data.item.is_booked_by_inmate == 1 &&
                          data.item.user_status == 1)) && 
                      checkTransfer(data.item)
                    "
                    v-b-tooltip.hover
                    :title="$t('Reject')"
                    @click="rejectAppointment(data.item.id)"
                    icon="XIcon"
                    svgClasses=" h-5 hover:text-danger stroke-current"
                    class="ml-1"
                  />
                </div>
                <feather-icon
                  v-if="data.item.reschedule_waiting_confirmation != 0"
                  v-b-tooltip.hover
                  :title="$t('Show')"
                  icon="EyeIcon"
                  svgClasses=" h-5 hover:text-danger stroke-current"
                  @click="
                    $router.push('/company/appointment/show/' + data.item.id)
                  "
                />

                <feather-icon
                  v-if="
                    data.item.reschedule_waiting_confirmation != 0 &&
                    data.item.current_status == '0' &&
                    data.item.is_cancelled == '0' &&
                    (data.item.is_confirmed == 1 ||
                      data.item.automatic_booking_confirmed ||
                      data.item.type == 'walkin')
                  "
                  v-b-tooltip.hover
                  :title="$t('Complete')"
                  id="status"
                  svgClasses=" h-5 hover:text-danger stroke-current"
                  :icon="
                    data.item.current_status == '0' &&
                    data.item.is_cancelled == '0'
                      ? 'StopCircleIcon'
                      : 'DiscIcon'
                  "
                  svg-classes="stroke-current text-primary"
                  @click="updateStatus(data.item)"
                />

                <feather-icon
                  v-if="
                    data.item.is_confirmed &&
                    data.item.current_status == 0 &&
                    data.item.is_cancelled == '0'
                  "
                  v-b-tooltip.hover
                  :title="$t('Cancel')"
                  @click="display(data.item.id)"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-1"
                />
              </div>
            </template>
          </b-table>
          <b-pagination
            v-if="rows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            class="float-right"
          ></b-pagination>
        </div>
      </b-card>
      <b-modal
        id="custom-modal"
        ok-variant="cancel"
        cancel-variant="primary"
        v-model="activePromptCancel"
        :title="$t('CancelAppointment')"
        :ok-title="$t('Cancel')"
        :cancel-title="$t('CancelAppointment')"
        :is-valid="check"
        @ok="close"
        @close="close"
        @cancel="submitForm"
        centered
        :cancel-disabled="disabled"
      >
        <div class="con-exemple-prompt">
          <div class="vx-col md:w-full w-full">
            <strong>
              <!-- <label>{{ $t("Reason") }}</label> -->
              <p>{{ $t("ReasonNote") }}</p>
            </strong>
            <b-textarea
              v-model="rejectMessage"
              rows="2"
              name="reason"
              :placeholder="$t('Reason')"
              @input="checkMessage"
            ></b-textarea>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="custom-modal"
        v-model="activeRejectPromptCancel"
        :title="$t('RejectAppointment')"
        :ok-title="$t('Cancel')"
        :cancel-title="$t('RejectAppointment')"
        :is-valid="check"
        centered
        :cancel-disabled="disabled"
        @cancel="submitRejectForm()"
        ok-variant="cancel"
        cancel-variant="primary"
        @ok="close"
        @close="close"
      >
        <div class="con-exemple-prompt">
          <div class="vx-col md:w-full w-full">
            <strong>
              <label>{{ $t("Reason") }}</label>
            </strong>
            <b-textarea
              v-model="rejectMessage"
              rows="2"
              name="reason"
              :placeholder="$t('Reason')"
              @input="checkMessage"
            ></b-textarea>
          </div>
        </div>
      </b-modal>

      <b-modal
        v-if="appointmentDetail != null"
        id="max-appointment-popup"
        :title="appointmentDetail.popTitle"
        v-model="evenPopup"
        centered
        hide-footer
      >
        <b-overlay
          :show="show1"
          :variant="variant"
          :opacity="opacity"
          :blur="blur"
          rounded="lg"
          spinner-variant="primary"
          z-index="999999"
        >
          <div class="con-exemple-prompt">
            <div class="vx-col md:w-full w-full">
              <p>
                <b>{{ appointmentDetail.department.department_name }}</b>
              </p>
              <p class="mt-2">
                {{ appointmentDetail.date }}
                {{ appointmentDetail.start_time }} -
                {{ appointmentDetail.end_time }}
              </p>
            </div>
            <div
              class="participant mt-5"
              v-if="appointmentDetail.participant_list.length > 0"
            >
              <feather-icon
                class="mr-3"
                icon="UserIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
              />
              {{
                appointmentDetail.participant_list.length +
                " " +
                $t("Participants")
              }}

              <ul
                :class="[
                  { 'add-scroll mt-2': readMore },
                  { 'remove-scroll mt-2': !readMore },
                ]"
              >
                <li
                  :key="index"
                  v-for="(val, index) of appointmentDetail.participant_list"
                >
                  <feather-icon
                    style="cursor: pointer"
                    class="mr-3 mt-3 pl-5"
                    icon="LinkIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    @click="copyCode(val.participant_conference_link)"
                  />
                  {{ val.user_name }}
                </li>
              </ul>
            </div>
            <a
              v-if="appointmentDetail.participant_list.length > 5 && !readMore"
              style="cursor: pointer"
              @click="readMore = true"
              >Read More</a
            >
            <div class="">
          <div class="w-full mt-5"  v-if="!checkTransfer(appointmentDetail)">
                  <div>
                        <!-- <h4 class="text-center">
                          {{$t('TransferAppointmentStatus')}}
                        </h4> -->
                           <b-button
                    variant="primary"
                    class="float-right"
                    @click="
                      $router.push('/company/appointment/show/' + appointmentDetail.id)
                    "
                  >
                    {{ $t("Details") }}
                  </b-button>
                  </div>
                </div>
              <div
                class="mt-5 mb-5 vx-col appdetail-footer flex-rev"
                v-if="!show1"
                 :class="(rescheduleButtons(appointmentDetail) && checkTransfer(appointmentDetail)) ? 'flex-content':''"
              >
           <div
                  v-if="
                    appointmentDetail.type != 'walkin' &&
                    appointmentDetail.is_cancelled == 0 &&
                    appointmentDetail.department
                      .automatic_booking_confirmation == 0 &&
                    (appointmentDetail.is_confirmed == null ||
                      appointmentDetail.transfer_status == 1) &&
                    !(
                      appointmentDetail.is_confirmed == null &&
                      appointmentDetail.transfer_status == 0 &&
                      appointmentDetail.transferred_by != null
                    )
                  "
                >
                  <b-button
                    v-if="
                      appointmentDetail.is_confirmed == null &&
                      (appointmentDetail.is_booked_by_inmate == 0 ||
                        (appointmentDetail.is_booked_by_inmate == 1 &&
                          appointmentDetail.user_status == 1))
                    "
                    class="mr-4 mb-4 vs-button-success"
                    variant="success"
                    @click="acceptAppointment(appointmentDetail.id)"
                    >{{ $t("Accept") }}</b-button
                  >
                  <b-button
                    v-if="
                      appointmentDetail.is_confirmed == null &&
                      (appointmentDetail.is_booked_by_inmate == 0 ||
                        (appointmentDetail.is_booked_by_inmate == 1 &&
                          appointmentDetail.user_status == 1))
                    "
                    variant="danger"
                    class="mr-4 mb-4 vs-button-danger"
                    @click="rejectAppointment(appointmentDetail.id)"
                    >{{ $t("Reject") }}</b-button
                  >
                </div>

                <div  > 
                  <b-button
                     v-if="rescheduleButtons(appointmentDetail) && checkTransfer(appointmentDetail)"
                    variant="info"
                    class="mr-4"
                    @click="rescheduleAppointment(appointmentDetail)"
                  >
                    {{ $t("RescheduleButton") }}
                  </b-button>
                  <b-button
                     v-if="
                      ((appointmentDetail.is_booked_by_inmate == 1 &&
                        appointmentDetail.user_status != 1) ||
                      appointmentDetail.current_status == 1 ||
                      appointmentDetail.is_cancelled == 1 ||
                      appointmentDetail.type == 'walkin' ||
                      appointmentDetail.department.automatic_booking_confirmation == 1 ||
                      (appointmentDetail.department.automatic_booking_confirmation == 0 &&
                        appointmentDetail.is_confirmed != null)) && checkTransfer(appointmentDetail)
                    "
                    variant="primary"
                    class="mr-4"
                    @click="
                      $router.push(
                        '/company/appointment/show/' + appointmentDetail.id
                      )
                    "
                  >
                    {{ $t("Details") }}
                  </b-button>
                  <template v-if="appointmentDetail.is_inside_buffer_mins">
                    <a
                      v-if="appointmentDetail.current_status != 1 &&
                    appointmentDetail.is_cancelled == 0 &&
                    appointmentDetail.is_missedcall == 0 &&
                    appointmentDetail.conference_link &&
                    (appointmentDetail.type == 'walkin' ||
                      appointmentDetail.department
                        .automatic_booking_confirmation == 1 ||
                      (appointmentDetail.department
                        .automatic_booking_confirmation == 0 &&
                        appointmentDetail.is_confirmed == 1))"
                      style="border: 1px solid #7367f0; color: #7367f0"
                      :href="appointmentDetail.conference_link +'/' +appointmentDetail.id"
                      class="mt-4 mb-4 btn mr-4 btn btn-outline-primary"
                      target="_blank"
                      @click.prevent.stop="redirectToApp(appointmentDetail.id)"
                      >{{ $t("Join") }}</a
                    >
                  </template>
                </div>
           
              </div>
            </div>
          </div>
        </b-overlay>
      </b-modal>
    </div>
    <!-- new appointment block and new button -->
    <b-modal
      id="custom-modal"
      v-model="dragModal"
      :title="$t('Appointment')"
      centered
      hide-footer
      @close="closeDrag"
    >
      <div class="con-exemple-prompt">
        <div class="row">
          <div class="w-full text-center sm:w-full">
            <span v-if="!is_block">
              <b-button
                variant="success"
                class="mr-4 mb-4 vs-button-danger"
                @click="unblockApp"
                >{{ $t("Unblock") }}</b-button
              >
              <b-button
                variant="danger"
                class="mr-4 mb-4 vs-button-danger"
                @click="dragModal = false"
                >{{ $t("Cancel") }}</b-button
              >
            </span>
            <span v-else>
              <b-button
                variant="danger"
                class="mr-4 mb-4 vs-button-danger"
                @click="blockApp"
                >{{ $t("Block") }}</b-button
              >
              <b-button
                class="mr-4 mb-4 vs-button-success"
                variant="success"
                @click="createApp"
                >{{ $t("NewAppointment") }}</b-button
              >
            </span>
          </div>
        </div>
      </div>
    </b-modal>
    <!--  -->
    <!--  sidebar-->
    <div id="drag-sidebar">
      <b-sidebar
        id="drag-sidebar1"
        class="mr-5"
        sidebar-class="sidebar-lg"
        :visible="dragSidebar"
        bg-variant="white"
        shadow
        backdrop
        right
        no-header
        header-class="header-sidebar"
        :title="$t('AddAppointment')"
        :width="'400px'"
        z-index="99999"
      >
        <!-- Header -->
        <template #default="{ hide }">
          <div class="vx-col mb-0 ml-5 mr-5 drag_modal">
            <h5 class="mt-5">
              {{ $t("AddAppointment") }}
              <feather-icon
                class="ml-1 cursor-pointer float-right"
                icon="XIcon"
                size="10"
                @click="clear"
                svgClasses="h-5 w-5"
              />
            </h5>

            <b-form>
              <div class="vx-col">
                <label class="vs-input--label"
                  >{{ $t("Department") }} <span class="red">*</span></label
                >

                <v-select
                  name="department"
                  id="department"
                  class=""
                  v-model="department"
                  v-validate="'required'"
                  label="department_name"
                  :options="options"
                  :data-vv-as="$t('Department')"
                  :placeholder="$t('Search')"
                  @input="changeDepartment"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon"
                      >{{ option.department_name }}
                    </span>
                    <feather-icon
                      v-if="department.id == option.id"
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('department')"
                  >{{ errors.first("department") }}</span
                >
              </div>
              <div class="vx-col">
                <div class="flex items-center mt-4 walk-card">
                  <b-form-checkbox
                    size="lg"
                    v-model="offer"
                    name="check-button"
                    switch
                    :disabled="checkDepartment"
                    @change="chageOffer()"
                  >
                  </b-form-checkbox>
                  <span class="ml-4">{{ $t("OfferOptions") }}</span>
                </div>
              </div>

              <div class="vx-col mt-5" v-if="offer">
                <b-button
                  variant="primary"
                  class="pl-5 pr-5"
                  @click="getDepartmentSlots()"
                >
                  {{ $t("SelectSlots") }}
                </b-button>
              </div>

              <div
                id="time-slot"
                class="relative mt-5 confhub vx-row"
                v-if="offer"
                ref="time"
              >
                <h5 class="pl-5 w-full slot-message" v-if="slots.length > 0">
                  <span
                    v-if="
                      slots[0].slots.length == 0 && slots[1].slots.length == 0
                    "
                  >
                    Slots not available
                  </span>
                </h5>
                <div
                  v-for="(slot, index) in slots"
                  :key="index"
                  :class="'w-1/2 pl-2 pr-2 slot-' + index"
                  :style="
                    length == 0 && index == 0 ? 'display:none' : 'display:block'
                  "
                >
                  <div class="w-full text-center">
                    <feather-icon
                      v-if="index == 0 && checkArrow(slot.today_date)"
                      icon="ArrowLeftCircleIcon"
                      class="float-left"
                      svgClasses="w-6 h-6"
                      @click="getDepartmentSlots(-1, slot.today_date)"
                    />
                    <span
                      id="today-date"
                      class="text-size"
                      style="text-transform: capitalize"
                      v-if="slot.slots.length > 0"
                    >
                      {{ slot.today_date | displayDate }}
                      <feather-icon
                        v-if="index == 1 && checkRightArrow(slot.today_date)"
                        icon="ArrowRightCircleIcon"
                        class="float-right"
                        svgClasses="w-6 h-6"
                        @click="getDepartmentSlots(1, slot.today_date)"
                      />
                    </span>
                  </div>

                  <div :class="slots.length > 2 ? 'scroll' : ''">
                    <div
                      id="slot-list"
                      class="slot-list mt-2"
                      v-for="(val, index2) in slot.slots"
                      :key="index2"
                    >
                      <b-button
                        v-if="slot.today_date"
                        variant="border"
                        :id="'time-button-' + index2 + index + slot.today_date"
                        class="time-button"
                        type="button"
                        @click="
                          timeSlotSelected(
                            val.start_time,
                            slot.today_date,
                            index2,
                            index
                          )
                        "
                        >{{ val.start_time }}</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="offer && !slots.length">
                <router-link to="/company/ordinary" id="workshift-link">{{
                  $t("WorkshiftLink")
                }}</router-link>
              </div>
              <b-button
                v-if="offer"
                variant="light"
                @click="copySnippet"
                class="pl-5 mt-5 ml-2"
                >{{ $t("CopySnippet") }}</b-button
              >
              <div class="vx-col mt-5" v-if="!offer">
                <label class="vs-input--label">{{ $t("StartTime") }}</label>

                <flat-pickr
                  id="start_time1"
                  :placeholder="$t('SelectDate')"
                  v-model="start_time"
                  class="form-control bg-white w-full"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    defaultDate: start_time,
                    time_24hr: true,
                  }"
                  @input="startChangeDate"
                />
              </div>
              <div class="vx-col mt-5" v-if="!offer">
                <label class="vs-input--label">{{ $t("EndTime") }}</label>

                <flat-pickr
                  id="end_time1"
                  :placeholder="$t('SelectDate')"
                  v-model="end_time"
                  class="form-control bg-white w-full"
                  :config="{
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    minDate: start_time,
                    time_24hr: true,
                  }"
                  @input="endChangeDate"
                />
              </div>
              <div
                class="vx-col mt-5"
                v-if="
                  department.many_to_many || (!department.many_to_many && !seen)
                "
              >
                <div class="batch-row" v-if="department.many_to_many">
                  <label class="vs-input--label"
                    >{{ $t("Customers") }} <span class="red">*</span></label
                  >

                  <v-select
                    multiple
                    v-model="participates1"
                    v-validate="!seen ? 'required' : ''"
                    :options="user_list"
                    label="name"
                    :data-vv-as="$t('Customers')"
                    :placeholder="$t('Search')"
                    name="customers"
                    id="customers"
                    :clearable="true"
                  >
                    <template v-slot:option="option">
                      <span :class="option.icon">{{ option.name }} </span>
                      <feather-icon
                        v-if="participates1.id == option.id"
                        icon="CheckIcon"
                        class="float-right"
                        svgClasses="w-5 h-5"
                      />
                    </template>
                  </v-select>
                </div>
                <div v-else>
                  <label class="vs-input--label"
                    >{{ $t("Customers") }} <span class="red">*</span></label
                  >
                  <v-select
                    v-model="participates"
                    v-validate="!seen ? 'required' : ''"
                    :options="user_list"
                    :readonly="Boolean($route.params.user_id)"
                    label="name"
                    :data-vv-as="$t('Customers')"
                    :placeholder="$t('Search')"
                    name="customers1"
                    id="customers1"
                    :clearable="!Boolean($route.params.user_id)"
                    @input="deSelected"
                  >
                    <template v-slot:option="option">
                      <span :class="option.icon">{{ option.name }} </span>
                      <feather-icon
                        v-if="participates.id == option.id"
                        icon="CheckIcon"
                        class="float-right"
                        svgClasses="w-5 h-5"
                      />
                    </template>
                  </v-select>

                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('customers1')"
                    >{{ errors.first("customers1") }}</span
                  >
                </div>
              </div>
              <div class="vx-col mt-5 card">
                <b-button class="text-success" v-on:click="showCustomer">
                  {{
                    seen ? $t("SelectCustomer") : "+ " + $t("AddNew")
                  }}</b-button
                >
              </div>
              <div v-if="seen">
                <!-- Booking form starts here -->

                <div
                  class="vx-row"
                  v-for="(field, index) in formFields"
                  :key="index"
                >
                  <div
                    class="vx-col md:w-full w-full"
                    v-if="field.shown && field.type == 'input'"
                  >
                    <label class="vs-input--label"
                      >{{
                        $t(field.label != undefined ? field.label : $t(index))
                      }}
                      <span v-if="field.required" class="red">*</span></label
                    >
                    <b-form-input
                      size="lg"
                      v-validate="{
                        required: field.required,
                        email: index == 'email' ? true : false,
                        max:
                          index == 'age'
                            ? 2
                            : index == 'first_name' || index == 'last_name'
                            ? 20
                            : false,
                        min_value: index == 'age' ? 1 : false,
                      }"
                      :name="'schedule.' + index"
                      :data-vv-as="
                        $t(field.label != undefined ? field.label : index)
                      "
                      :placeholder="
                        field.label != undefined ? field.label : $t(index)
                      "
                      v-model="scheduleEvent1[index]"
                      class="w-full"
                      :type="index == 'age' ? 'number' : 'text'"
                    ></b-form-input>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + index)"
                      >{{ errors.first("schedule." + index) }}</span
                    >
                  </div>
                  <div
                    class="vx-col md:w-full w-full"
                    v-if="field.shown && field.type == 'contact'"
                  >
                    <label class="contact_number_label"
                      >{{ $t(index) }}
                      <span v-if="field.required" class="red">*</span></label
                    >

                    <!-- 
                      <span v-if="field.required">*</span> -->
                    <vue-tel-input
                      size="large"
                      v-validate="{
                        required: field.required,
                        regex: /^(?=.*[0-9])[- +()0-9]+$/,
                        min: 12,
                      }"
                      v-model="scheduleEvent1[index]"
                      class="w-full contact_number"
                      v-on:country-changed="countryChanged"
                      v-bind="bindProps"
                      :name="'schedule.' + index"
                      :data-vv-as="$t(index)"
                      :placeholder="$t(index)"
                    ></vue-tel-input>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + index)"
                      >{{ errors.first("schedule." + index) }}</span
                    >
                  </div>
                  <div
                    class="vx-col md:w-full w-full"
                    v-if="field.shown && field.type == 'select'"
                  >
                    <label
                      >{{ $t(index) }}
                      <span v-if="field.required" class="red">*</span></label
                    >

                    <!-- <span v-if="field.required">*</span>  -->
                    <v-select
                      class="mt-1 w-full gender_array"
                      v-validate="{ required: field.required }"
                      v-model="scheduleEvent1[index]"
                      :options="genderArray"
                      :name="'schedule.' + index"
                      :data-vv-as="$t(index)"
                      :placeholder="$t('Select') + $t(index)"
                    >
                      <template v-slot:option="option">
                        <span :class="option.icon">{{ option.label }} </span>
                        <feather-icon
                          v-if="scheduleEvent1[index] == option.label"
                          icon="CheckIcon"
                          class="float-right"
                          svgClasses="w-5 h-5"
                        />
                      </template>
                    </v-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + index)"
                      >{{ errors.first("schedule." + index) }}</span
                    >
                  </div>

                  <div
                    class="vx-col md:w-full w-full"
                    v-if="field.shown && field.type == 'calender'"
                  >
                    <label class="contact_number_label"
                      >{{ $t(index) }}
                      <span v-if="field.required" class="red">*</span></label
                    >

                    <!-- <span v-if="field.required">*</span>  -->

                    <b-form-datepicker
                      :placeholder="$t('Select') + $t(index)"
                      v-model="scheduleEvent1[index]"
                      class="datepick mb-2"
                      v-validate="{ required: field.required }"
                      :format="format"
                      :disabled-dates="state.disabledDates"
                      :name="'schedule.' + index"
                      :data-vv-as="$t(index)"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :show-decade-nav="showDecadeNav"
                      :hide-header="hideHeader"
                    ></b-form-datepicker>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + index)"
                      >{{ errors.first("schedule." + index) }}</span
                    >
                  </div>

                  <div
                    class="vx-col w-full"
                    v-if="field.shown && field.type == 'file'"
                  >
                    <label
                      >{{ $t(index) }}
                      <span v-if="field.required" class="red">*</span></label
                    >
                    <!-- <span v-if="field.required">*</span>  -->
                    <v-select
                      class="mt-1 w-full"
                      v-validate="{ required: field.required }"
                      v-model="scheduleEvent1['type']"
                      :options="documentTypeArray"
                      :data-vv-as="$t(index)"
                      :name="'schedule.' + index"
                      :placeholder="$t('Select') + $t(index)"
                    >
                      <template v-slot:option="option">
                        <span :class="option.icon">{{ option.label }} </span>
                        <feather-icon
                          v-if="
                            scheduleEvent1['type'] &&
                            scheduleEvent1['type'].code == option.code
                          "
                          icon="CheckIcon"
                          class="float-right"
                          svgClasses="w-5 h-5"
                        />
                      </template>
                    </v-select>
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + index)"
                      >{{ errors.first("schedule." + index) }}</span
                    >
                  </div>

                  <!-- =================== -->
                  <div
                    class="vx-col w-full mt-8"
                    v-if="field.shown && field.type == 'file'"
                  >
                    <label>{{ $t("Upload") + " " + $t("document") }}</label>
                    <span v-if="field.required" class="red">*</span><br />
                    <img :src="url" class="mr-8 rounded mt-1" width="85px" />
                    <input
                      ref="uploadDocumentInput"
                      type="file"
                      v-validate="{
                        required:
                          field.required &&
                          url.includes('default_upload.d4c75de8.png'),
                        size: 2048,
                      }"
                      class="hidden"
                      accept="image/*, application/pdf"
                      name="uploadDocument"
                      id="uploadDocument"
                      :data-vv-as="$t('document')"
                      @change="selectedFile"
                    />

                    <b-button
                      variant="primary"
                      class="mr-4 mb-4 mt-2"
                      size="lg"
                      @click="$refs.uploadDocumentInput[0].click()"
                      >{{ $t("Upload") }}</b-button
                    >
                    <br />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('schedule.' + 'uploadDocument')"
                      >{{ errors.first("schedule." + "uploadDocument") }}</span
                    >
                  </div>

                  <!-- ==================== -->
                </div>
                <!-- <div class="vx-col">
                        <b-button
                          variant="primary"
                          @click="schedule('schedule')"
                          class="mt-5 block"
                          >{{ $t("ScheduleEvent") }}</b-button
                        >
                      </div> -->
              </div>
              <!-- Booking form ends here -->

              <div class="vx-col mt-5" v-if="department.many_to_many">
                <b-button variant="primary" @click="addInput" class="pl-5 pr-5">
                  {{ $t("AnotherParticipate") }}
                </b-button>
                <feather-icon
                  v-b-tooltip.hover
                  :title="$t('Remove')"
                  @click="removeInput"
                  icon="TrashIcon"
                  svgClasses="w-7 h-7 hover:text-danger stroke-current"
                  class="ml-5"
                />

                <feather-icon
                  v-b-tooltip.hover
                  :title="$t('Reset')"
                  @click="resetInput"
                  icon="DeleteIcon"
                  svgClasses="w-7 h-7 hover:text-danger stroke-current"
                  class="ml-5"
                />
              </div>

              <div class="vx-col mt-5">
                <div
                  class="batch-row"
                  :id="`${index}`"
                  v-for="(items, index) in manyUsers"
                  :key="index"
                >
                  <v-select
                    :name="`${index}`"
                    class="mt-5 w-90"
                    :id="`${index}`"
                    v-model="list[index]"
                    label="name"
                    v-validate="'required'"
                    :options="user_list"
                    :data-vv-as="$t('Participates')"
                    :placeholder="$t('Participates')"
                    @input="selectParticipate($event, index)"
                  >
                    <template v-slot:option="option">
                      <span :class="option.icon">{{ option.name }} </span>
                      <feather-icon
                        v-if="list[index] && list[index].id == option.id"
                        icon="CheckIcon"
                        class="float-right"
                        svgClasses="w-5 h-5"
                      />
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="w-full xs:w-full sm:w-full mt-5" v-if="confirmToggle">
                <div class="flex walk-card">
                  <b-form-checkbox
                    v-model="confirmation"
                    size="lg"
                    name="cell_width"
                    switch
                  >
                  </b-form-checkbox>
                  <span class="ml-4 mr-3 mt-1">{{
                    $t("AskConfirmation")
                  }}</span>
                </div>
              </div>
              <div class="vx-col">
                <b-button variant="primary" @click="addEvent">{{
                  offer ? $t("SendEmail") : $t("Add")
                }}</b-button>
              </div>
            </b-form>
          </div>
        </template>
        <!-- <template #footer="{ hide }">
         
        </template> -->
      </b-sidebar>

      <b-sidebar
        id="appointment_sidebar"
        bg-variant="white"
        v-model="active1"
        shadow
        backdrop
        right
        no-header
        :title="$t('AppointmentDetails')"
        :width="'350px'"
        z-index="99999"
      >
        <div class="vx-col mb-0 ml-5 mr-5 drag_modal">
          <div class="mt-5">
            <h5 class="mt-5">
              {{ $t("AppointmentDetails") }}
              <feather-icon
                class="ml-1 cursor-pointer float-right"
                icon="XIcon"
                size="10"
                @click="active1 = false"
                svgClasses="h-5 w-5"
              />
            </h5>
            <b-table-simple responsive>
              <b-tbody>
                <b-tr v-if="this.$store.getters.roles != 'staff'">
                  <b-th>{{
                    $t(
                      this.$store.getters.currentUser.is_unio == 1
                        ? "Inmate"
                        : "StaffD"
                    )
                  }}</b-th>
                  <b-td style="white-space: normal">{{ rowdata.staff }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("User") }}:</b-th>
                  <b-td>{{ rowdata.users }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("Date") }}:</b-th>
                  <b-td>{{ rowdata.date }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("StartTime") }}:</b-th>
                  <b-td> {{ rowdata.start_time | displayTime(is_unio) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("EndTime") }}:</b-th>
                  <b-td>{{ rowdata.end_time | displayTime(is_unio) }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("Type") }}:</b-th>
                  <b-td
                    ><span v-if="rowdata == 'one-to-one'">{{
                      $t("OneToOne")
                    }}</span>
                    <span v-else-if="rowdata == 'walkin'">{{
                      $t("Walkin")
                    }}</span>
                    <span v-else>{{ $t("Conference") }}</span></b-td
                  >
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("AppointmentType") }}:</b-th>
                  <b-td>{{
                    rowdata.is_inperson == 1
                      ? $t("InPersonal")
                      : $t("VideoConfereneType")
                  }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("CurrentStatus") }}:</b-th>
                  <b-td
                    ><div v-if="rowdata.is_cancelled == 1">
                      {{ $t("Canceled") }}
                    </div>
                    <div
                      v-else-if="
                        rowdata.user_status == 2 || rowdata.is_confirmed == 0
                      "
                    >
                      {{ $t("Rejected") }}
                    </div>
                    <div v-else>
                      {{
                        rowdata.current_status == "1"
                          ? $t("Completed")
                          : $t("Pending")
                      }}
                    </div></b-td
                  >
                </b-tr>
                <b-tr>
                  <b-th>{{ $t("Action") }}:</b-th>
                  <b-td>
                    <div>
                      <div
                        id="accept"
                        v-if="
                          rowdata.type != 'walkin' &&
                          rowdata.is_cancelled == 0 &&
                          rowdata.automatic_booking_confirmed == 0
                        "
                      >
                        <feather-icon
                          v-if="
                               rowdata.is_confirmed == null &&
                            (rowdata.is_booked_by_inmate == 0 ||
                              (rowdata.is_booked_by_inmate == 1 &&
                                rowdata.user_status == 1)) && 
                      checkTransfer(rowdata)
                          "
                          v-b-tooltip.hover
                          :title="$t('Accept')"
                          @click="acceptAppointment(rowdata.id)"
                          icon="CheckIcon"
                          svgClasses="h-5 hover:text-danger stroke-current"
                        />

                        <feather-icon
                          v-if="
                          rowdata.is_confirmed == null &&
                            (rowdata.is_booked_by_inmate == 0 ||
                              (rowdata.is_booked_by_inmate == 1 &&
                                rowdata.user_status == 1))  && 
                      checkTransfer(rowdata)
                          "
                          v-b-tooltip.hover
                          :title="$t('Reject')"
                          @click="rejectAppointment(rowdata.id)"
                          icon="XIcon"
                          svgClasses=" h-5 hover:text-danger stroke-current"
                          class="ml-1"
                        />
                      </div>
                      <feather-icon
                        v-b-tooltip.hover
                        :title="$t('Show')"
                        icon="EyeIcon"
                        svgClasses=" h-5 hover:text-danger stroke-current"
                        @click="
                          $router.push(
                            '/company/appointment/show/' + rowdata.id
                          )
                        "
                      />

                      <feather-icon
                        v-if="
                          rowdata.current_status == '0' &&
                          rowdata.is_cancelled == '0' &&
                          (rowdata.is_confirmed == 1 ||
                            rowdata.automatic_booking_confirmed ||
                            rowdata.type == 'walkin')
                        "
                        v-b-tooltip.hover
                        :title="$t('Complete')"
                        id="status"
                        svgClasses=" h-5 hover:text-danger stroke-current"
                        :icon="
                          rowdata.current_status == '0' &&
                          rowdata.is_cancelled == '0'
                            ? 'StopCircleIcon'
                            : 'DiscIcon'
                        "
                        svg-classes="stroke-current text-primary"
                        @click="updateStatus(rowdata)"
                      />

                      <feather-icon
                        v-if="
                          rowdata.current_status == 0 &&
                          rowdata.is_cancelled == '0'
                        "
                        v-b-tooltip.hover
                        :title="$t('Cancel')"
                        @click="display(rowdata.id)"
                        icon="TrashIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="ml-1"
                      />
                    </div>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </div>
      </b-sidebar>
    </div>
  </b-overlay>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import $ from "jquery";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import moduleCalendar from "@/store/calendar/moduleCalendar.js";
require("vue-simple-calendar/static/css/holidays-us.css");

import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  setStaffAppId,
  setStaffAppUuid,
  setAppUuid,
  appointmentBufferTimer,
  phoneConfig,
  unsubscribeChannels,
  debounce,
} from "@/utils/helper";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Validator } from "vee-validate";
import "moment-timezone";
import listPlugin from "@fullcalendar/list";

const channels = {
  public: [],
};

let dataSend, getAppointments;

export default {
  components: {
    vSelect,
    CalendarView,
    CalendarViewHeader,
    Datepicker,
    FullCalendar,
    flatPickr,
  },
  filters: {
    displayDate(date) {
      return moment(date).format("DD-MMM");
    },
    displayTime(v, is_unio) {
      if (v) {
        if (is_unio == 1) return moment(v, "hh:mm A").format("HH:mm");
        else return moment(v, "hh:mm A").format("hh:mm A");
      }
    },
    showDateValue(date, calendarView, lang) {
      let check = calendarView == "month" || calendarView == "list";
      if (check) {
        let t = moment(date).lang(lang).format("MMM YYYY");
        console.log(`%c ${t}`, "color:bl");
        return moment(date).lang(lang).format("MMM YYYY");
      } else if (calendarView == "week") {
        let year1 = moment(date).startOf("week").format("YYYY");
        let year2 = moment(date).endOf("week").format("YYYY");
        let date1, date2;
        if (year1 != year2) {
          date1 = moment(date).lang(lang).startOf("week").format("DD MMM YYYY");
          date2 = moment(date).lang(lang).endOf("week").format("DD MMM YYYY");
        } else {
          date1 = moment(date).lang(lang).startOf("week").format("DD MMM");
          date2 =
            moment(date).lang(lang).endOf("week").format("DD MMM") +
            ", " +
            year1;
        }
        return date1 + " - " + date2;
      } else {
        return moment(date).lang(lang).format("DD MMM YYYY");
      }
    },
  },
  data() {
    return {
      confirmToggle: false,
      confirmation: false,
      calendarView1: null,
      config: {
        defaultView: "month",
        // eventRender: function(event, element) {
        // 	console.log(event)
        // }
      },
      selected: "",
      slots: [],
      scheduleEvent: [],
      scheduleEvent1: [],

      format: "yyyy-MM-dd",
      state: {
        disabledDates: {
          // Disable all dates up to specific date
          from: new Date(), // Disable all dates after specific date
        },
      },
      documentTypeArray: [
        { code: 1, label: this.$t("Passport") },
        { code: 2, label: this.$t("IdentityCard") },
        { code: 3, label: this.$t("DrivingLicense") },
      ],
      block_id: "",
      start_time: "",
      end_time: "",
      booking_email: "",
      booking_contact: "",
      booking_gender: "",
      booking_type: "",
      genderArray: [
        this.$t("Male"),
        this.$t("Female"),
        this.$t("Prefernottosay"),
      ],
      bindProps: phoneConfig(this.$t("ContactNumber")),
      show_canceled: false,
      show_completed: false,
      show_rejected: false,
      no_show: false,
      render: true,
      showDate: new Date(),
      disabledFrom: false,
      id: 0,
      events: [],

      langHe: he,
      langEn: en,

      url: require("@/assets/images/portrait/small/default_upload.png"),
      calendarView: "week",

      calendarViewTypes: [
        {
          label: "Month",
          val: "month",
        },
        {
          label: "Week",
          val: "week",
        },
        {
          label: "Day",
          val: "day",
        },
        {
          label: "List",
          val: "list",
        },
      ],
      cancel_id: "",
      seen: false,
      reject_id: "",
      appointActionType: "",
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Staff", "User", "Day", "Date", "StartTime", "EndTime"],
      headerVal: ["staff", "users", "day", "date", "start_time", "end_time"],
      staffs: [],
      activePrompt: false,
      activePromptCancel: false,
      activeRejectPromptCancel: false,
      val: true,
      message: "",
      rejectMessage: "",
      status: 1,
      check: false,
      checkReject: false,
      value: "",
      calendar_dates: [],
      selectedDate: "",
      role: "staff",
      is_unio: 0,
      calendarOptions: {
        locale: this.$i18n.locale,
        plugins: [
          dayGridPlugin,
          interactionPlugin,
          listPlugin,
          timeGridPlugin, // needed for dateClick
        ],
        headerToolbar: {
          left: "today prev,next",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        // initialView: "timeGridWeek",
        initialEvents: [], // alternatively, use the `events` setting to fetch from a feed
        editable: false,
        selectable: true,
        selectMirror: false,
        dayMaxEvents: true,
        weekends: true,
        dayMaxEvents: 2,
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents,
        dateClick: this.handleDateClick,
        contentHeight: 600,
        now: moment(new Date())
          .tz(this.$store.getters.currentUser.timezone)
          .format("YYYY-MM-DD HH:mm:ss"),
        nowIndicator: true,
        scrollTime:
          moment(new Date())
            .tz(this.$store.getters.currentUser.timezone)
            .format("HH") -
          2 +
          ":00:00",
      },
      currentEvents: [],
      calendar_status: false,
      filterTime: null,
      evenPopup: false,
      appointmentDetail: null,
      readMore: false,
      show: false,
      show1: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      is_block: true,
      formFields: {},
      fields: [
        {
          key: this.$store.getters.roles != "staff" ? "staff" : "",
          label:
            this.$store.getters.currentUser.is_unio == 1 ? "Inmate" : "StaffD",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "users",
          label: "User",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "date",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "start_time",
          label: "StartTime",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "end_time",
          label: "EndTime",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "is_inperson",
          label: "AppointmentType",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "current_status",
          label: "CurrentStatus",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "action", label: "Action" },
      ],
      fieldResponsive: [
        {
          key: "users",
          label: "User",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "start_time",
          label: "StartTime",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "current_status",
          label: "CurrentStatus",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      disabled: true,
      dragModal: false,
      dragSidebar: false,
      options: [],
      department: "",
      offer: false,
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      user_list: [],
      participates: "",
      participates1: "",
      allItems: [],

      manyUsers: [],
      list: [],
      list1: [],
      list2: [],
      selectedDate: [],
      dragged_data: [],
      selectedDate1: [],
      company: [],
      addNewFrom: false,
      timeSlots: [],
      length: -1,
      checkDepartment: true,
      showDecadeNav: true,
      hideHeader: true,
      totalRows: 1,
      selectdSlotIds: [],
      hideArrow: false,
      rightHideArrow: false,
      hide: "display:none",
      show: "display:block",
      sWidth: null,
      active1: false,
      rowdata: [],
      rowdataIndex: 0,
      errorImage: "",
      staffImageUrl: require("@/assets/images/portrait/small/avatar-s-27.png"),
      staffList: [],
      selectedStaff: [],
      selfData: {},
    };
  },

  created() {
    this.getStaffList();
    dataSend = debounce(this.dataSend);
    getAppointments = debounce(this.getAppointments);

    window.addEventListener("resize", this.screenWidth);
    this.company = this.$store.getters.currentUser;
    this.role = this.$store.getters.currentUser.user_role;

    this.is_unio = this.$store.getters.currentUser.is_unio;
    this.allItems = this.user_list;
    this.getFields();
    this.getALLUsers();

    this.getDismissed();

    this.scheduleEvent = {
      email: "",
      first_name: "",
      last_name: "",
      timezone:
        moment.tz.guess() !== "Asia/Calcutta"
          ? moment.tz.guess()
          : "Asia/Kolkata",
    };
  },
  beforeDestroy() {
    unsubscribeChannels(channels.public);
    channels.public.splice(0, Infinity);
    appointmentBufferTimer.clearTimeout();
  },
  mounted() {
    // AUTO REFRESH WHEN NEW APPOINTMENT CREATED
    const id = this.$store.getters.company_id;
    channels.public.push("appointmentAutoRefresh" + id);
    Echo.channel("appointmentAutoRefresh" + id).listen(
      "AppointmentAutoRefresh",
      (response) => {
        const requestData = this.getData(this.selectedDate);
        dataSend(requestData);
      }
    );

    this.screenWidth();

    this.getDepartmentList();
    // if (this.calendarView1 == null) this.openAddNewEvent(this.showDate);
    // if (this.calendarView1 !== null)
    //   this.config.defaultView = this.calendarView1;
  },
  computed: {
    rows() {
      if (this.staffs.appointment_list)
        return this.staffs.appointment_list.length;
      else return 0;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.calendarOptions.locale = value;
      },
    },
    message(value) {
      if (value != "") {
        this.flag = "";
        this.check = true;
      } else {
        this.check = false;
      }
    },
    rejectMessage(value) {
      if (value != "") {
        this.flag = "";
        this.checkReject = true;
      } else {
        this.checkReject = false;
      }
    },
    department(value) {
      this.department = value || "";
      this.checkDepartment = false;
      if (this.department == "" || Object.keys(this.department).length < 0) {
        this.checkDepartment = true;
        this.offer = false;
      }
      this.slots = [];
      this.getDepartmentSlots();

      if (this.addNewFrom) {
        this.getTimeSlots();
      }
    },
  },

  /**
   * copy embed text
   */

  methods: {
        displayTitle(element) {
      let direct = element.department_staff_user_id != null;
      let title = element.title;
      let type = element.type;
      let staff_name = element.staff_name;
      let user_name = element.user_name;
      if (direct) {
        if (type == "one-to-one") return `${title} - ${user_name}`;
        else if (type == "conference") return `${title} - Conference`;
      } else {
        if (type == "one-to-one")
          return `${title} - ${element.staff_name} - ${user_name}`;
        else if (type == "conference") return `${title} - Conference`;
      }
    },
      checkTransfer(appointmentDetail){
      return   !(appointmentDetail.is_confirmed == null && appointmentDetail.transfer_status == 0 && appointmentDetail.transferred_by != null)
    },
    checkMonth(date) {
   return moment(date).isSame(this.selectedDate, 'month');
    },
    rescheduleAppointment(data) {
      this.confirmToggle = true;
      this.dragModal = false;
      this.evenPopup = false;
      this.dragSidebar = true;
      let temp = [];
      let user = [];
      this.options.map((el, index) => {
        if (data.department_id == el.id) temp = el;
      });
      this.department = temp;
      this.user_list.map((el, index) => {
        if (data.user_id == el.id) user = el;
      });
      this.participates = user;
      let startTime = data.date + " " + data.start_time;
      let endTime = data.date + " " + data.end_time;
      const format1 = "YYYY-MM-DD HH:mm";
      this.start_time = moment(startTime).format(format1);

      this.end_time = moment(endTime).format(format1);
    },
    rescheduleButtons(data) {
      // let accept=  data.department.automatic_booking_confirmation == 1 ||
      //                 (data.department.automatic_booking_confirmation == 0 &&
      //                   data.is_confirmed != null)
      let hidden = data.is_confirmed != 0 || data.current_status != 1;
      return hidden;
    },
    myRowClickHandler(record, index) {
      this.rowdata = record;
      this.rowdataIndex = index;
      this.showSidebar = true;
      if (this.sWidth > 768) this.active1 = false;
      else this.active1 = true;
    },

    screenWidth() {
      this.sWidth = window.innerWidth;
    },
    /**
     *
     * submitForm   method  for reject Appointment from listing
     **/
    getDismissed() {
      this.show = true;
      this.$store
        .dispatch("GetDismissed")
        .then((res) => {
          this.show = false;
          console.log(res.data.data);
          let response = res.data.data;
          this.show_rejected = response.is_meeting_rejected;
          this.show_completed = response.is_meeting_completed;
          this.no_show = response.is_meeting_noshow;
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : getDismissed() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *
     * submitForm   method  for reject Appointment from listing
     **/
    submitDismissed() {
      this.show = true;
      let data = {
        is_meeting_completed: this.show_completed ? true : false,
        is_meeting_rejected: this.show_rejected ? true : false,
        is_meeting_noshow: this.no_show ? true : false,

        from_calendar: true,
      };

      this.$store
        .dispatch("SaveDismissed", data)
        .then((res) => {
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : submitDismissed() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    getcalendarView(value) {
      value = this.calendarView1;
      if (value == "day") {
        this.config.defaultView = "day";
        this.calendarOptions.initialView = "timeGridDay";
        this.calendarView = "day";
      }
      if (value == "week") {
        this.config.defaultView = "week";
        this.calendarOptions.initialView = "timeGridWeek";
        this.calendarView = "week";
      }
      if (value == "month" || value == null) {
        this.config.defaultView = "month";
        this.calendarOptions.initialView = "dayGridMonth";
        this.calendarView = "month";
      }
      if (value == "list") {
        this.config.defaultView = "list";
        this.calendarOptions.initialView = "listMonth";
        this.calendarView = "list";
      }
      this.openAddNewEvent(this.showDate);
    },
    deSelected(val) {
      if (val == null) this.participates = [];
    },
    openSidebar() {
      this.dragSidebar = !this.dragSidebar;
    },
    changeDepartment(val) {
      this.timeSlots = [];
      this.selectdSlotIds = [];
    },
    checkArrow(date) {
      let date1 = moment(new Date()).format("YYYY-MM-DD");
      if (date == date1) return false;
      else return true;
    },
    checkRightArrow(date) {
      // let date1= moment(this.end_time).format("YYYY-MM-DD");
      // if(date==date1)
      // return false;
      // else
      return true;
    },
    startChangeDate(date) {
      this.selectedDate1.start = date;
      this.selectedDate1.startStr = date;
    },
    endChangeDate(date) {
      this.selectedDate1.end = date;
      this.selectedDate1.endStr = date;
    },
    checkArray(arr) {
      arr.map((el, index) => {
        if (index == 0) console.log(el.slots.length);
      });
    },
    copyCodeSnippet(output) {
      function listener(e) {
        e.clipboardData.setData("text/html", output);
        e.clipboardData.setData("text/plain", output);
        e.preventDefault();
      }
      document.addEventListener("copy", listener);
      document.execCommand("copy");
      document.removeEventListener("copy", listener);
    },
    copySnippet() {
      let data = {
        selected_time: this.timeSlots,
        department_id: this.department.id,
      };
      this.$store
        .dispatch("CopySnippet", data)
        .then((res) => {
          let output = res.data.data;
          console.log("html code ", output);
          this.$copyText(output).then(
            (e) => {
              this.copyCodeSnippet(output);
              this.$toasted.show(this.$t("CopyText"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            },
            function (e) {
              this.$toasted.show(this.$t("CopyTextError"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            }
          );
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : CopySnippet() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    chageOffer() {
      if (!this.offer) {
        this.selected = "";
      }
      if (this.offer) this.getDepartmentSlots();
    },
    timeSlotSelected(time, date, index2, index1) {
      this.selected = date + " " + time;
      let max = 5;
      let timeSlots = this.timeSlots;
      let count = 0;
      let slotDates = [];
      timeSlots.map((el, index) => {
        let slotDate = moment(el, "YYYY-MM-DD").format("YYYY-MM-DD");
        if (slotDate == date) count++;
        slotDates.push(slotDate);
      });
      let slotUnique = this.uniqueArray(slotDates);
      console.table(
        `count-${count}---timeslot--${this.timeSlots}---timeslot length--${this.timeSlots.length}---slots---${slotUnique}---slot length---${slotUnique.length}--ids--${this.selectdSlotIds}--ids--${this.selectdSlotIds.length}`
      );

      if (count < 3 && this.selectdSlotIds.length < max) {
        timeSlots.push(this.selected);
        this.timeSlots = this.uniqueArray(timeSlots);
      }

      this.checkActiveClass(index2, index1, date, count, max, slotUnique);
    },
    checkActiveClass(index2, index1, date, count, max, slotUnique) {
      let check = $("#time-button-" + index2 + index1 + date).hasClass(
        "isActive"
      );

      let id = `#time-button-${index2 + index1 + date}`;
      if (check || slotUnique.includes(id)) {
        $("#time-button-" + index2 + index1 + date).removeClass("isActive");
        var indexVal = this.selectdSlotIds.indexOf(
          "time-button-" + index2 + index1 + date
        );
        if (indexVal !== -1) {
          this.selectdSlotIds.splice(indexVal, 1);
        }
        let remove = this.timeSlots.includes(this.selected);
        let index = this.timeSlots.indexOf(this.selected);
        remove ? this.timeSlots.splice(index, 1) : false;
      } else {
        if (count < 3 && this.selectdSlotIds.length < max) {
          $("#time-button-" + index2 + index1 + date).addClass("isActive");
          if (this.selectdSlotIds.length <= max)
            this.selectdSlotIds.push("time-button-" + index2 + index1 + date);
        }
      }
    },
    uniqueArray(myArray) {
      var unique = myArray.filter((v, i, a) => a.indexOf(v) === i);
      return unique;
    },
    checkSlots(index) {
      console.log(this.selectdSlotIds);
      console.log("-----------------------");
      this.selectdSlotIds.forEach((element) =>
        $("#" + element).addClass("isActive")
      );
    },

    showCustomer() {
      this.seen = !this.seen;
    },
    removeParticipate(event, index) {},
    selectParticipate(event, index) {
      this.list1 = this.list1.filter((item) => item !== value);
    },
    addEvent() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.eventSubmit();
        }
      });
      // alert("footer");
    },
    eventSubmit() {
      this.show = true;
      this.success = "";
      this.error = "";
      let unique_users = [];

      if (this.participates1) {
        this.participates1.map((el, index) => {
          this.list.push(el);
        });
        let id_array = this.list.map((x) => x.id);
        unique_users = id_array.filter((item, i, ar) => ar.indexOf(item) === i);
      } else {
        if (this.participates.id) {
          this.list.push(this.participates);
          if (this.list.length) {
            let id_array = this.list.map((x) => x.id);
            unique_users = id_array.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
          }
        }
      }

      let daySlots = moment(this.selectedDate1.start).format("dddd");
      let data = {};
      data.appointment_details = {
        company_id:
          this.$store.getters.roles == "staff" ||
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        day: daySlots,
        date: moment(this.selectedDate1.start).format("YYYY-MM-DD"),
        start_time: moment(this.selectedDate1.startStr).format("LT"),
        end_time: moment(this.selectedDate1.endStr).format("LT"),
        department_id: this.department.id,
        type: "conference",
        // is_rescheduled: this.cancelAppointment ? "1" : "0",
        is_rescheduled: "0",
        rescheduled_id: "",
      };

      if (this.confirmToggle) {
        data.appointment_details.is_rescheduled = 1;
        data.appointment_details.rescheduled_id = this.appointmentDetail.id;
        data.appointment_details.is_confirmation = this.confirmation ? 1 : 0;
      }
      this.scheduleEvent.appointment_details = data.appointment_details;
      if (this.confirmToggle) {
        // this.scheduleEvent.is_rescheduled = 1;
        // this.scheduleEvent.rescheduled_id = this.appointmentDetail.id;
        this.scheduleEvent.is_confirmation = this.confirmation ? 1 : 0;
      }
      this.scheduleEvent.is_user_booked = false;
      this.scheduleEvent.is_booked_by_inmate = 3;
      this.scheduleEvent.user_ids = unique_users ? unique_users : [];
      this.scheduleEvent.is_offer = this.offer ? 1 : 0;
      this.scheduleEvent.staff_timezone = this.$store.getters.currentUser.timezone;
      this.scheduleEvent.timezone =
        moment.tz.guess() !== "Asia/Calcutta"
          ? moment.tz.guess()
          : "Asia/Kolkata";
      this.scheduleEvent.current_date = moment(
        this.start_time,
        "YYYY-MM-DD hh:mm A"
      ).format("Y-MM-D");
      this.scheduleEvent.time = moment(
        this.start_time,
        "YYYY-MM-DD hh:mm A"
      ).format("hh:mm A");
      // data.document = this.scheduleEvent.type.code;
      // data.document_path=this.images;
      this.scheduleEvent.selected_time = this.timeSlots;
      let obj = this.scheduleEvent1;

      let a = this;
      let keys = Object.keys(obj);
      keys.map((e) => {
        a.scheduleEvent[e] = obj[e];
      });
      this.scheduleEvent = a.scheduleEvent;
      console.log("rahul changes", this.scheduleEvent);
      if (this.list.length) {
        if (!this.scheduleEvent.email) {
          this.scheduleEvent.first_name = this.list[0].first_name;
          this.scheduleEvent.last_name = this.list[0].last_name;
          this.scheduleEvent.email = this.list[0].email;
          this.scheduleEvent.contact_number = this.list[0].contact_number;
          this.scheduleEvent.language = this.list[0].language;
          this.scheduleEvent.timezone = this.list[0].timezone;
          this.scheduleEvent.gender = this.list[0].gender;
          this.scheduleEvent.age = this.list[0].age;
          this.scheduleEvent.dob = this.list[0].dob;
          this.scheduleEvent.country = this.list[0].country;
          this.scheduleEvent.city = this.list[0].city;
          this.scheduleEvent.custom_field_one = this.list[0].custom_field_one;
          this.scheduleEvent.custom_field_two = this.list[0].custom_field_two;
          this.scheduleEvent.document = this.list[0].type;
        }
      }

      if (
        this.scheduleEvent.type != null &&
        this.scheduleEvent.type != undefined
      ) {
        this.scheduleEvent.document = this.scheduleEvent.type.code;
      } else {
        if (this.scheduleEvent.document == null)
          this.scheduleEvent.document = null;
      }
      if (this.images) {
        this.scheduleEvent.document_path = this.images;
      } else this.scheduleEvent.document_path = null;

      this.scheduleEvent.is_unio = this.$store.getters.currentUser.is_unio;
      const dataForm = new FormData();
      $.each(this.scheduleEvent, function (key, value) {
        if (key == "appointment_details") {
          dataForm.append(key, JSON.stringify(value));
        } else {
          if (value == null) {
            dataForm.append(key, "");
          } else {
            if (key == "dob") {
              dataForm.append(
                key,
                value.length == 10 ? value : value.toISOString()
              );
            } else dataForm.append(key, value);
          }
        }
      });
      if (
        this.scheduleEvent.is_offer == 0 ||
        (this.scheduleEvent.is_offer == 1 && this.timeSlots.length > 0)
      ) {
        this.clear();
        this.$store
          .dispatch("ScheduleEvent", dataForm)
          .then((res) => {
            let response = res.data.data;

            this.show = false;
            // let length=Object.keys(response).length;
            this.clear();
            this.getALLUsers();
            this.getDepartmentList();
            this.timeSlots = [];
            this.seen = false;
            this.calendar_status = false;
            this.openAddNewEvent(this.selectedDate);

            let event = this.$t("EventScheduled");
            let mail = this.$t("MailSuccessfull");
            let message = response.is_offer == 1 ? mail : event;

            this.$toasted.show(message, {
              className: "top-alert",
              position: "top-center",
              type: "success",
              duration: 2000,
            });
            message = "";
          })
          .catch((error) => {
            this.clear();
            this.seen = false;
            this.$log.error(
              "File : BookAppointment.vue | Function : schedule() | Error :",
              error
            );
            this.show = false;
            // Error response
            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });
            return false;
          });
      } else {
        this.show = false;
        this.$swal({
          text: "Please select slot",
          type: "warning",
          confirmButtonText: this.$t("OK"),
          confirmButtonColor: "#7367F0",
        });
      }
    },
    // hideModal() {
    //   this.department = '';
    //   this.participates = '';
    //   $('.drag_modal').find('.input_fields').val('');
    //   $('.contact_number').find('input').val('');
    //   $('.datepick').find('input').val('');
    //   this.closeDrag();
    // },
    addInput() {
      this.manyUsers.push(this.user_list1);
      return false;
    },
    removeInput() {
      this.manyUsers.pop();
    },
    resetInput() {
      this.list = [];
      this.manyUsers = [];
    },
    closeDrag() {
      this.dragModal = false;
      this.dragSidebar = false;
    },
    clear() {
      this.timeSlots = [];
      this.selectdSlotIds = [];
      this.seen = false;
      this.selected = "";
      this.scheduleEvent1 = [];
      this.participates = "";
      this.participates1 = "";
      this.list2 = [];
      // this.department = "";
      this.dragSidebar = false;
      this.resetInput();
      this.offer = false;
      this.url = require("@/assets/images/portrait/small/default_upload.png");
      this.scheduleEvent = {
        email: "",
        first_name: "",
        last_name: "",
        timezone:
          moment.tz.guess() !== "Asia/Calcutta"
            ? moment.tz.guess()
            : "Asia/Kolkata",
      };
    },
    /**
     * Country Code
     */
    countryChanged(country) {
      this.country = "+" + country.dialCode;
    },
    selectedFile(event) {
      this.error = "";
      var filePath = event.target.files[0].name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.error =
          this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
            ? this.$t(error.replace(/[\s\/]/g, ""))
            : error;
        this.$toasted.show(this.error, {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        $("#uploadDocument").val("");
      } else {
        this.images = event.target.files[0];
        if (this.images.type == "application/pdf")
          this.url = require("@/assets/images/portrait/small/default_pdf.png");
        else this.url = URL.createObjectURL(this.images);
      }
    },
    getFields() {
      if (this.$route.name == "add-normal-appointment") {
        this.dragSidebar = true;
        this.addNewFrom = true;
      }
      var id =
        this.$store.getters.roles == "staff" ||
        this.$store.getters.roles == "assistant"
          ? this.$store.getters.currentUser.company_id
          : this.$store.getters.currentUser.id;
      //this.scheduleEvent = this.$store.getters.currentUser;
      this.$store
        .dispatch("getFields", id)
        .then((res) => {
          if (res.data.data) {
            if (res.data.data.form_fields) {
              this.formFields = res.data.data.form_fields;
            }
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getFields() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    getDepartmentList() {
      var company_id =
        this.$store.getters.roles == "assistant"
          ? this.$store.getters.currentUser.company_id
          : this.$store.getters.currentUser.id;
      var data = { id: company_id };
      this.$store.dispatch("GetAppDepartmentList").then((res) => {
        this.options = res.data.data;
        if (this.calendarView1 == null) {
          this.calendarView1 = res.data.calendar_type;
          this.getcalendarView(res.data.calendar_type);
        }
      });
    },
    async getALLUsers() {
      try {
        const res = await this.$store.dispatch("getAllUsers");
        const users = res.data.data.map((user) => {
          return {
            ...user,
            get name() {
              return `${this.first_name} ${this.last_name}`;
            },
          };
        });

        if (this.$route.params.user_id) {
          const userId = this.$route.params.user_id;
          const hasUser = users.find((user) => user.id == userId);
          if(hasUser){
    this.user_list = [hasUser];
          this.participates = this.user_list.at(0);
          }
          else
          this.user_list = users;
        } else this.user_list = users;
      } catch (error) {
        console.error(error);
      }
    },
    unblockApp() {
      this.dragModal = false;
      this.show = true;
      var data = { id: this.block_id };
      this.$store.dispatch("deleteBlockSlot", data).then((res) => {
        this.show = false;
        this.calendar_status = false;
        this.openAddNewEvent(this.selectedDate);
        this.block_id = "";
        this.$toasted.show(this.$t("UnblockSuccess"), {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      });
    },
    blockApp() {
      this.dragModal = false;
      this.show = true;

      var block_data = this.staffs.staff_blocked_slots;
      var delete_ids = [];

      for (let i = 0; i < block_data.length; i++) {
        var start = moment(
          block_data[i].start_date + " " + block_data[i].start_time
        ).format("Y-MM-D HH:mm");
        var end = moment(
          block_data[i].end_date + " " + block_data[i].end_time
        ).format("Y-MM-D HH:mm");

        var start1 = new Date(
          moment(
            block_data[i].start_date + " " + block_data[i].start_time
          ).format("Y-MM-D HH:mm")
        );
        var end1 = new Date(
          moment(block_data[i].end_date + " " + block_data[i].end_time).format(
            "Y-MM-D HH:mm"
          )
        );

        var drag_start = new Date(
          moment(this.dragged_data.start).format("Y-MM-D HH:mm")
        );
        var drag_end = new Date(
          moment(this.dragged_data.end).format("Y-MM-D HH:mm")
        );

        if (drag_start < start1 && drag_end > end1) {
          delete_ids.push(block_data[i].id);
          if (drag_start > start1) {
            this.dragged_data.start = start;
          }
          if (drag_end < end1) {
            this.dragged_data.end = end;
          }
        }

        if (drag_start >= start1 && drag_start <= end1) {
          delete_ids.push(block_data[i].id);
          if (drag_start > start1) {
            this.dragged_data.start = start;
          }
          if (drag_end < end1) {
            this.dragged_data.end = end;
          }
        }
        if (drag_end >= start1 && drag_end <= end1) {
          delete_ids.push(block_data[i].id);
          if (drag_start > start1) {
            this.dragged_data.start = start;
          }
          if (drag_end < end1) {
            this.dragged_data.end = end;
            this.getDepartmentSlots();
          }
        }
      }

      let data = {
        start_date: moment(this.dragged_data.start).format("Y-MM-D"),
        end_date: moment(this.dragged_data.end).format("Y-MM-D"),
        slots: [
          {
            start_time: moment(this.dragged_data.start).format("HH:mm"),
            end_time: moment(this.dragged_data.end).format("HH:mm"),
          },
        ],
        delete_id: delete_ids,
      };
      this.$store.dispatch("saveBlockSlot", data).then((res) => {
        this.show = false;
        this.calendar_status = false;
        this.openAddNewEvent(this.selectedDate);
        this.$toasted.show(this.$t("BlockSuccess"), {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      });
    },

    createApp() {
      this.dragModal = false;
      this.dragSidebar = true;
    },
    handleDateSelect(event) {
      this.clear();
      this.slots = [];
      this.addNewFrom = false;
      if (
        this.calendarOptions.initialView != "dayGridMonth" &&
        this.is_unio == 0
      ) {
        var val = true;
        var data = this.staffs.calendar_appointment;
        for (let i = 0; i < data.length; i++) {
          var start = new Date(
            moment(data[i].start_time).format("Y-MM-D HH:mm")
          );
          var end = new Date(moment(data[i].end_time).format("Y-MM-D HH:mm"));
          var check_start = new Date(
            moment(event.start).format("Y-MM-D HH:mm")
          );
          var check_end = new Date(moment(event.end).format("Y-MM-D HH:mm"));
          if (check_start < start && check_end > end) {
            var val = false;
            break;
          } else if (check_start >= start && check_start < end) {
            var val = false;
            break;
          } else if (check_end > start && check_end <= end) {
            var val = false;
            break;
          } else {
            var val = true;
          }
        }

        if (!val) {
          this.$swal({
            text: this.$t("BlockFailure"),
            type: "warning",
            confirmButtonText: this.$t("OK"),
            confirmButtonColor: "#7367F0",
          });
        }
        this.dragModal = val;
      }
      this.dragSidebar = false;
      this.dragged_data = event;
      this.start_time = event.startStr;
      this.end_time = event.endStr;
      this.is_block = true;
      this.filterTime = moment(event.startStr).format("HH:mm:ss");
      //this.selectedDate1 = event;
    },
    changeSwitch() {
      this.calendar_status = false;
      this.submitDismissed();
      this.openAddNewEvent(this.showDate);
    },
    handleDateClick(event) {
      this.openAddNewEvent(event.dateStr);
    },
      handleEventClick(clickInfo) {
      // this.readMore = false;
      // this.filterTime = moment(clickInfo.event.startStr).format("HH:mm:ss");
      // this.openAddNewEvent(clickInfo.event.start);
      // if (clickInfo.event.extendedProps.block_id) {
      //   this.dragModal = true;
      //   this.is_block = false;
      //   this.block_id = clickInfo.event.extendedProps.block_id;
      // } else getAppointments(clickInfo.event.id);
      this.$router.push('/company/appointment/show/' + clickInfo.event.id);
    },
    changeDate(value) {
      this.show = true;
      const format = "YYYY-MM-DD";
      this.showDate = new Date(this.showDate);
      var dateTime = moment(this.showDate).format(format);
      $(".cv-weeks").find(".cv-day").removeClass("today");
      $(".d" + dateTime).addClass("today");

      this.calendarView = value;
      if (value == "day") {
        this.calendarOptions.initialView = "timeGridDay";
      }
      if (value == "week") {
        this.calendarOptions.initialView = "timeGridWeek";
      }
      if (value == "month") {
        this.calendarOptions.initialView = "dayGridMonth";
      }
      if (value == "list") {
        this.calendarOptions.initialView = "listMonth";
      }
      this.filterTime = null;
      this.calendarOptions.initialDate = this.showDate;
      this.calendar_status = false;
      var data = this.getData(this.selectedDate);
      $(".cv-weeks").find(".cv-day").removeClass("today");
      $(".d" + data.current_date).addClass("today");
      dataSend(data);
    },

    openAddNewEvent(d) {
      this.showDate = new Date(d.startDate != undefined ? d.startDate : d);
      const format = "YYYY-MM-DD";

      var dateTime = moment(this.showDate).format(format);
      $(".cv-weeks").find(".cv-day").removeClass("today");
      $(".d" + dateTime).addClass("today");
      this.selectedDate = d.startDate != undefined ? d.startDate : d;
      var data = this.getData(this.selectedDate);
      $(".cv-weeks").find(".cv-day").removeClass("today");
      $(".d" + data.current_date).addClass("today");
      dataSend(data);
    },
    //dataSend
    checkMessage() {
      this.disabled = this.rejectMessage.length ? false : true;
    },

    dataSend(data) {
      this.show = true;

      var action =
        this.role == "admin" ||
        this.role == "moderator" ||
        this.role == "super-moderator"
          ? "GetAppointments"
          : "GetStaffAppointments";

      data.show_canceled = this.show_rejected ? true : false;
      data.show_completed = this.show_completed;
      data.show_rejected = this.show_rejected;
      data.no_show = this.no_show;

      data.startweek = moment(this.showDate)
        .startOf("week")
        .format("YYYY-MM-DD");
      data.endweek = moment(this.showDate).endOf("week").format("YYYY-MM-DD");
      this.filterTime = this.filterTime != "00:00:00" ? this.filterTime : null;
      data.filterTime = this.calendarView != "month" ? this.filterTime : null;
      data.calendar_type = this.calendarView;
      this.$store
        .dispatch(action, data)
        .then((res) => {
          this.show = false;
          this.events = [];
          this.staffs = res.data.data;

          appointmentBufferTimer.setAppointments(
            res.data.data.calendar_appointment,
            function () {
              const requestData = this.getData(this.selectedDate);
              dataSend(requestData);
              if (this.appointmentDetail && this.appointmentDetail.id)
                getAppointments(this.appointmentDetail.id);
            }.bind(this)
          );

          this.totalRows = this.staffs.appointment_list.length;
          this.currentEvents = [];
          if (res.data.data.calendar_dates) {
            var keys = res.data.data.calendar_appointment;
            keys.map((element, index) => {
              let staffname;
              if (element.staff_id != null) {
                staffname =
                  element.title +
                  " " +
                  this.$t("With") +
                  " " +
                  element.staff_name;
              } else if (element.many_to_many) {
                staffname = "Conference";
              } else staffname = element.title;

              var format = this.is_unio == 1 ? "HH:mm" : "hh:mm A";

              element.start_appointment_time = moment(
                element.start_appointment_time,
                "hh:mm A"
              ).format(format);
              element.end_appointment_time = moment(
                element.end_appointment_time,
                "hh:mm A"
              ).format(format);

              console.log(element.is_inperson);
            var html = `<span class='month-view'>${
              element.start_appointment_time
            } - ${element.end_appointment_time} ${this.displayTitle(
              element
            )}</span>
            <span class='day-view'>${this.displayTitle(element)} <br> ${
              element.start_appointment_time
            } - ${
              element.end_appointment_time
            } <br> ${staffname}</span><span class='list-view'>${this.displayTitle(
              element
            )}</span>`;
                          var arr = {
                id: element.id,
                title: html,
                start: element.start_time,
                end: element.end_time,
                classNames: [element.appointment_time_status],
                appointment_id: element.id,
                is_inperson: element.is_inperson,
              };
              this.currentEvents.push(arr);
            });
          }

          if (res.data.data.staff_blocked_slots) {
            var keys = res.data.data.staff_blocked_slots;
            keys.map((element, index) => {
              var arr = {
                id: element.id,
                title: "",
                start: element.start_date + " " + element.start_time,
                end: element.end_date + " " + element.end_time,
                classNames: ["gray"],
                block_id: element.id,
              };
              this.currentEvents.push(arr);
            });
          }
          //  this.calendar_status = false;
          this.calendar_status = true;
          this.calendarOptions.initialEvents = this.currentEvents;
          this.calendarOptions.now = moment(new Date())
            .tz(this.$store.getters.currentUser.timezone)
            .format("YYYY-MM-DD HH:mm:ss");
          $(".fc-day").removeClass("calendar-today");
          $(".fc-day[data-date=" + data.current_date + "]").addClass(
            "calendar-today"
          );

          $(".fc-day").removeClass("week-selected");
          $(
            ".fc-col-header-cell[data-date=" + data.current_date + "]"
          ).addClass("week-selected");

          $(".gray").parent().addClass("custome-gray");

          // this.$refs.calendar.$emit('refetch-events');
        })
        .catch((error) => {
          alert(error);
          this.$log.error(
            "File : List.vue | Function : openAddNewEvent() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    handleEvents(events) {
      this.currentEvents = events;
      let str;
      let currentViewType = events.map((el, index) => {
        if (index == 0) str = el._context.currentViewType;
      });
      if (str == "timeGridDay") this.calendarView = "day";
      if (str == "timeGridWeek") this.calendarView = "week";
      if (str == "dayGridMonth") this.calendarView = "month";
      this.openAddNewEvent(this.showDate);
    },

    //getData
    getData(selected) {
      var day = moment(selected);
      var result = {
        day: day.format("dddd").toLowerCase(),
        month: day.format("MMMM").toLowerCase(),
        year: day.format("YYYY"),
      };
      if (this.calendarView == "day") {
        this.value = result.day;
      }
      if (this.calendarView == "year") {
        this.value = result.year;
      }
      if (this.calendarView == "month" || this.calendarView == "list") {
        this.value = result.month;
      }
      if (this.calendarView == "list") this.calendarView = "list";

      const format = "YYYY-MM-DD";
      var date = new Date(selected);
      var dateTime = moment(date).format(format);
      var data = {
        type: this.calendarView,
        current_date: dateTime,
        value: this.calendarView == "week" ? dateTime : this.value,
      };

      if (this.calendarView == "list") {
        this.calendarView = "list";
        data.type = "month";
      }

      if (
        this.role == "admin" ||
        this.role == "moderator" ||
        this.role == "super-moderator"
      ) {
        data.company_id = this.$store.getters.currentUser.id;
      } else {
        data.staff_id =
          this.role == "assistant"
            ? this.selectedStaff.id
            : this.$store.getters.currentUser.staff_id;
      }
      return data;
    },

    //calendar
    updateMonth(val) {
      this.show = true;
      if (this.calendarView == "month" || this.calendarView == "list") {
        if (val == 1)
          this.showDate = moment(this.showDate)
            .add(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD");
        else
          this.showDate = moment(this.showDate)
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD");
      } else if (this.calendarView == "week") {
        if (val == 1)
          this.showDate = moment(this.showDate)
            .add(1, "weeks")
            .startOf("week")
            .format("YYYY-MM-DD");
        else
          this.showDate = moment(this.showDate)
            .subtract(1, "weeks")
            .startOf("week")
            .format("YYYY-MM-DD");
      } else {
        if (val == 1)
          this.showDate = moment(this.showDate)
            .add(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
        else
          this.showDate = moment(this.showDate)
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD");
      }
      const format = "YYYY-MM-DD";
      this.showDate = new Date(this.showDate);
      var dateTime = moment(this.showDate).format(format);
      $(".cv-weeks").find(".cv-day").removeClass("today");
      $(".d" + dateTime).addClass("today");

      this.calendarOptions.initialDate = this.showDate;
      this.filterTime = "";
      this.calendar_status = false;
      this.openAddNewEvent(this.showDate);
    },

    /**
     *
     * Display   method  for cancelAppointment from listing
     **/
    display(id) {
      this.active1 = false;
      this.cancel_id = id;
      this.activePromptCancel = true;
    },
    /**
     *
     * submitForm   method  for cancelAppointment from listing
     **/
    submitForm() {
      this.show = true;
      var data = {
        reason: this.rejectMessage,
        id: this.cancel_id,
      };
      var action =
        this.role == "admin" ||
        this.role == "moderator" ||
        this.role == "super-moderator"
          ? "CancelAppointment"
          : "CancelStaffAppointment";
      this.$store.dispatch(action, data).then((res) => {
        this.rejectMessage = "";
        this.show = false;
        this.calendar_status = false;
        this.openAddNewEvent(this.selectedDate);
        this.$toasted.show(this.$t("AppointmentCanceledSucess"), {
          className: "top-alert",
          position: "top-center",
          type: "success",
          duration: 2000,
        });
      });
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.staffs.appointment_list;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "Staff",
          "User",
          "Day",
          "Date",
          "StartTime",
          "EndTime",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * close   method  for close dialog box
     **/
    close() {
      this.message = "";
      this.rejectMessage = "";
      this.check = false;
      this.checkReject = false;
    },

    /**
     *
     * Display   method  for cancelAppointment from listing
     **/
    acceptAppointment(id) {
      this.active1 = false;
      this.reject_id = id;
      this.appointActionType = "accept";
      this.submitRejectForm();
    },
    /**
     *
     * Display  method  for rejectAppointment from listing
     **/
    rejectAppointment(id) {
      this.active1 = false;
      this.evenPopup = false;
      this.reject_id = id;
      this.activeRejectPromptCancel = true;
      this.appointActionType = "reject";
    },
    /**
     *
     * Update Status method  for update status of  appointment completed or pending
     **/
    updateStatus(staff) {
      this.$swal({
        text: this.$t("WantToCompletedStatus"),

        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      })
        .then((result) => {
          if (result.value) {
            this.active1 = false;
            this.show = true;

            var data = {
              status: this.status,
              id: staff["id"],
            };

            this.$store.dispatch("StaffUpdateStatus", data).then((res) => {
              this.show = false;
              this.staffs = res.data.data;
              this.calendar_status = false;
              this.openAddNewEvent(this.showDate);
              this.$toasted.show(this.$t("AppointmentMarkedCompleted"), {
                className: "top-alert",
                position: "top-center",
                type: "success",
                duration: 2000,
              });
            });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : updateStatus() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *
     * submitForm   method  for reject Appointment from listing
     **/
    submitRejectForm() {
      this.show1 = true;
      if (this.appointActionType == "accept") {
        this.show1 = true;
        var data = {
          is_confirmed: 1,
          appointment_id: this.reject_id,
        };
      } else {
        this.show = true;
        this.activeRejectPromptCancel = true;
        var data = {
          reason: this.rejectMessage,
          is_confirmed: 0,
          appointment_id: this.reject_id,
        };
      }
      this.$store.dispatch("BookingConfirmation", data).then((res) => {
        this.activeRejectPromptCancel = false;
        console.log("sssssssssssssssssssssss", res);
        this.rejectMessage = "";
        this.show1 = false;
        this.show = false;
        this.disabled = true;
        this.openAddNewEvent(this.selectedDate);
        this.render = false;
        getAppointments(this.reject_id);

        this.$toasted.show(
          this.appointActionType == "accept"
            ? this.$t("AppointmentAcceptSucess")
            : this.$t("AppointmentRejectedSucess"),
          {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          }
        );
      });
    },

    getAppointments($id) {
      this.show = true;
      var data = {
        id: $id,
        user_role: this.$store.getters.roles,
      };
      var api =
        data.user_role == "admin" ? "AppointmentShow" : "StaffAppointmentShow";
      this.$store
        .dispatch(api, data)
        .then((res) => {
          this.show = false;
          this.appointmentDetail = res.data.data;

          let timeFormat = this.is_unio == 1 ? "HH:mm" : "hh:mm A";
          this.appointmentDetail.start_time = moment(
            this.appointmentDetail.start_time,
            "hh:mm A"
          ).format(timeFormat);
          this.appointmentDetail.end_time = moment(
            this.appointmentDetail.end_time,
            "hh:mm A"
          ).format(timeFormat);

          this.appointmentDetail.popTitle = moment(this.appointmentDetail.date)
            .lang(this.$i18n.locale)
            .format("ddd, DD MMM YYYY");

          this.appointmentDetail.date = moment(this.appointmentDetail.date)
            .lang(this.$i18n.locale)
            .format("MMM DD, YYYY");

          this.evenPopup = true;
          this.render = true;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getAppointments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    redirectToApp(id) {
      const req = {
        id: this.appointmentDetail.company_conference_room_id,
        user_name: this.appointmentDetail.staff_first_name,
        is_enable_chat: this.appointmentDetail.department.is_enable_chat,
        conference_room: this.appointmentDetail.conference_room_name,
        pin: this.appointmentDetail.conferene_pin,
        confernce_room_data: true,
        conference_uuid: this.appointmentDetail.conference_uuid,
        uuid: this.appointmentDetail.uuid,
        appointment_id: this.appointmentDetail.id,
        is_direct_start: this.appointmentDetail.is_direct_start
      };
      this.$store.dispatch("startConference", req);
      this.$router.push({ path: "/company/walkin" });
      return;
      setStaffAppId(id);
      if (this.appointmentDetail.department.many_to_many == 0) {
        setStaffAppUuid(id, this.appointmentDetail.id);
      } else {
        setStaffAppUuid(
          this.appointmentDetail.conference_uuid,
          this.appointmentDetail.id
        );
      }
      setAppUuid(this.appointmentDetail.uuid, this.appointmentDetail.id);
    },

    copyCode(url) {
      navigator.clipboard.writeText(url).then(
        (e) => {
          this.$toasted.show(this.$t("CopyText"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        },
        function (e) {
          this.$toasted.show(this.$t("CopyTextError"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        }
      );
    },
    // type conversion
    capitalize(str) {
      let type = str.replace(/[^a-zA-Z ]/g, "").replace(/ /g, "");
      let conf = this.$t(type.charAt(0).toUpperCase() + type.slice(1));
      return conf.toLowerCase();
    },

    getTimeSlots() {
      moment.locale("en");
      var day = moment().format("dddd");
      day = day.toLowerCase();
      var data = {
        day: day,
        id: this.department.id,
        date: moment(moment(), "D/M/YYYY").format("YYYY-MM-DD"),
        timezone: this.$store.getters.currentUser.timezone,
      };
      this.$store
        .dispatch("GetDaySlots", data)
        .then((res) => {
          if (res.data.data.slots.length > 0) {
            this.start_time = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].start_time,
              "YYYY-MM-DD hh:mm A"
            ).format("YYYY-MM-DD HH:mm");
            this.end_time = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].end_time,
              "YYYY-MM-DD hh:mm A"
            ).format("YYYY-MM-DD HH:mm");
            this.selectedDate1.start = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].start_time,
              "YYYY-MM-DD hh:mm A"
            );
            this.selectedDate1.end = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].end_time,
              "YYYY-MM-DD hh:mm A"
            );
            this.selectedDate1.startStr = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].start_time,
              "YYYY-MM-DD hh:mm A"
            ).format("YYYY-MM-DD HH:mm");
            this.selectedDate1.endStr = moment(
              moment().format("YYYY-MM-DD") +
                " " +
                res.data.data.slots[0].end_time,
              "YYYY-MM-DD hh:mm A"
            ).format("YYYY-MM-DD HH:mm");
          } else {
            this.start_time = "";
            this.end_time = "";
            this.selectedDate1.start = "";
            this.selectedDate1.end = "";
            this.selectedDate1.startStr = "";
            this.selectedDate1.endStr = "";
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : BookInterview.vue | Function : getTimeSlots() | Error :",
            error
          );
          this.$vs.loading.close();
          return false;
        });
    },
    getDepartmentSlots(flag = 0, date = null) {
      this.slots = [];
      let obj = $(".time-button");
      let idList = Object.entries(obj).forEach(([key, value]) => {
        //  console.log(value.id);
      });
      let todaysDate = moment(new Date()).format("YYYY-MM-DD");

      if (date != null) {
        todaysDate = moment(
          this.selectedDate1.start,
          "dddd, MMMM D, YYYY"
        ).utcOffset(0);
        todaysDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        todaysDate.toISOString();
        todaysDate.format("YYYY-MM-DD");
        if (flag == 1)
          todaysDate = moment(date).add(1, "days").format("YYYY-MM-DD");
        if (flag == -1)
          todaysDate = moment(date).add(-2, "days").format("YYYY-MM-DD");
      }

      // let endDate = moment(this.end_time).format("YYYY-MM-DD");

      var data = {
        timezone: this.$store.getters.currentUser.timezone,
        department_id: this.department.id,
        is_appointment_offer: 1,
        todays_date: todaysDate,
        // end_date: endDate,
        is_staff: 1,
      };

      if (this.department.id) {
        this.$store
          .dispatch("GetDepartmentSlots", data)
          .then((res) => {
            this.slots = res.data.data;
            this.length = this.slots[0].slots.length;
            setTimeout(() => {
              this.checkSlots();
            }, 100);
          })
          .catch((error) => {
            this.$log.error(
              "File : BookInterview.vue | Function : getTimeSlots() | Error :",
              error
            );
            // this.$vs.loading.close();
            return false;
          });
      }
    },

    errorImg() {
      this.staffImageUrl = this.staffImageUrl;
    },

    /**
     *
     * getStaffs   method  for list all staffs data
     **/
    getStaffList() {
      let data;

      if (this.$store.getters.roles == "assistant") {
        this.selfData = {
          id: this.$store.getters.currentUser.id,
          first_name: this.$store.getters.currentUser.first_name,
          last_name: this.$store.getters.currentUser.last_name,
          email: this.$store.getters.currentUser.email,
          profile_image: this.$store.getters.currentUser.profile_image
            ? this.$store.getters.currentUser.profile_image
            : "",
        };

        this.selectedStaff = this.selfData;
        data = {
          company_id: this.$store.getters.currentUser.company_id,
          assisatant_id: this.$store.getters.currentUser.id,
          is_assistant: true,
        };

        let action = "GetOnlyStaff";
        this.$store
          .dispatch(action, data)
          .then((res) => {
            this.staffList = res.data.data;
            this.calendar_status = false;
            this.openAddNewEvent(this.showDate);
          })
          .catch((error) => {
            this.$log.error(
              "File : List.vue | Function : getStaffList() | Error :",
              error
            );
            // Error response

            this.error =
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error;
            this.$toasted.show(this.error, {
              className: "top-alert",
              position: "top-center",
              type: "error",
              duration: 2000,
            });

            return false;
          });
      }
    },

    setSelectedStaff(data) {
      this.selectedStaff = data;
      this.calendar_status = false;
      this.openAddNewEvent(this.showDate);
    },
  },
};
</script>

<style lang="scss" scope>
.flex-content{
      display: flex;
    margin-top: 10px;
}
.max-width-content{
      width: max-content;

}
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
.fc-daygrid-more-link,
.fc-daygrid-more-link:hover {
  color: #6e6b7b;
}

.cv-event {
  top: 1rem !important;
  width: auto !important;
}
.cv-event.offset0 {
  left: 7% !important;
}
.cv-event.offset1 {
  left: 21% !important;
}
.cv-event.offset2 {
  left: 35.5% !important;
}
.cv-event.offset3 {
  left: 50% !important;
}
.cv-event.offset4 {
  left: 64% !important;
}
.cv-event.offset5 {
  left: 79% !important;
}
.cv-event.offset6 {
  left: 93% !important;
}
.day span {
  text-transform: capitalize !important;
}

.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.con-exemple-prompt {
  padding: 10px;
  padding-bottom: 0px;
}

.vs-input {
  width: 100%;
  margin-top: 10px;
}
.highlight {
  background-color: rgba(var(--vs-success), 1);
  border-radius: 50%;
  padding: 0.43rem;
  margin: 0.4rem;
  text-align: center;
}
.demo-app-main {
  flex-grow: 1;
  padding: 2em;
}

// .fc-timegrid-event.orange {
//   background-color: #f9faaf;
//   border: 2px solid #f9cd57;
//   color: #626262 !important;
// }
// .fc-timegrid-event.red {
//   background-color: #f87c7c;
//   border: 2px solid #fc4545;
//   color: #fff !important;
// }

// .fc-timegrid-event.blue {
//   background-color: #a1dced;
//   border: 2px solid #47bbbb;
//   color: #626262 !important;
// }
/*.fc-daygrid-event {
  color: #626262 !important;
}
.fc-event-main {
  color: #626262 !important;
}*/
.fc-col-header-cell-cushion {
  // font-size: 1.5em;
  // color: #626262 !important;
}
.fc-daygrid-day-number {
  // font-size: 1.5em;
  //  color: #626262 !important;
}
 .simple-calendar-app a {
  color: rgba(var(--vs-primary), 1) !important;
}
.fc-button {
  background: rgba(var(--vs-primary), 1) !important;
}

.fc-timegrid-event.orange {
  background-color: #ff9f43;
  border: 2px solid #ff9f43;
  color: #fff !important;
}
.fc-timegrid-event.red {
  background-color: #f87c7c;
  border: 2px solid #f87c7c;
  color: #fff !important;
}
.fc-timegrid-event.green {
  background-color: #48da89;
  border: 2px solid #48da89;
  color: #fff !important;
}
.fc-timegrid-event.info {
  background-color: #00cfe8;
  border: 2px solid #00cfe8;
  color: #fff !important;
}
.fc-timegrid-event.yellow {
  background-color: #f9c80e;
  border: 2px solid #f9c80e;
  color: #fff !important;
}

.fc-timegrid-event.blue {
  background-color: #7367f0;
  border: 2px solid #7367f0;
  color: #fff !important;
}
.fc-timegrid-event.black {
  background-color: #6e6b7b;
  border: 2px solid #6e6b7b;
  color: #fff !important;
}
.red-dot {
  height: 11px;
  width: 11px;
  background-color: #fc4545;
  border-radius: 50%;
  display: inline-block;
}
.text-black {
  color: #6e6b7b;
}
.blue-dot {
  height: 11px;
  width: 11px;
  background-color: #7367f0;
  border-radius: 50%;
  display: inline-block;
}
.orange-dot {
  height: 11px;
  width: 11px;
  background-color: #f9cd57;
  border-radius: 50%;
  display: inline-block;
}
.info-dot {
  height: 11px;
  width: 11px;
  background-color: #00cfe8;
  border-radius: 50%;
  display: inline-block;
}
.black-dot {
  height: 11px;
  width: 11px;
  background-color: #6e6b7b;
  border-radius: 50%;
  display: inline-block;
}
.green-dot {
  height: 11px;
  width: 11px;
  background-color: #48da89;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 11px;
  width: 11px;
  background-color: #f9c80e;
  border-radius: 50%;
  display: inline-block;
}
.fc-button-active:focus {
  box-shadow: none !important;
}
.fc-timegrid-event .month-view,
.fc-timegrid-event .list-view {
  display: none;
}
.fc-daygrid-event .day-view,
.fc-daygrid-event .list-view {
  display: none;
}
.fc-list-event-title .month-view,
.fc-list-event-title .day-view {
  display: none;
}
.fc-daygrid-day-events,
a.fc-timegrid-event {
  overflow: hidden;
}
.fc .fc-daygrid-day.fc-day-today,
.fc .fc-timegrid-col.fc-day-today {
  background: none;
}
.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  display: none;
}
#appdetail footer {
  display: none;
}
#appdetail h3.dialog-title {
  text-align: center;
  color: #ffff;
}
#appdetail header.vs-dialog-header {
  background: #7367f0 !important;
}
.appdetail-footer {
  float: right;
}

.remove-scroll {
  max-height: 180px;
  overflow: hidden;
}
.add-scroll {
  max-height: 180px;
  overflow-y: scroll;
}
.calendar-today a.fc-daygrid-day-number {
  background: #7367f0;
  border-radius: 15px;
  color: #fff !important;
  width: 28px;
  text-align: center;
}
.week-selected a.fc-col-header-cell-cushion {
  color: #7367f0 !important;
}

#appdetail .vs-button-success {
  background: #fff !important;
  color: rgb(31, 170, 31);
  border: 1px solid rgb(31, 170, 31);
}
#appdetail .vs-button-danger {
  background: #fff !important;
  color: rgb(218, 25, 25);
  border: 1px solid rgb(218, 25, 25);
}
.header-sidebar {
  float: right;
}
.close {
  float: right;
}
.gray {
  background: rgba(1, 1, 1, 0.05);
  border: none;
  left: -2px !important;
  right: -2px !important;
  box-shadow: none;
}
.fc-daygrid-event.fc-daygrid-dot-event.fc-event.fc-event-start.fc-event-end.fc-event-today.gray {
  display: none !important;
}
a.fc-daygrid-event.fc-daygrid-dot-event.fc-event.fc-event-start.fc-event-end.fc-event-past.gray {
  display: none !important;
}
a.fc-daygrid-event.fc-daygrid-dot-event.fc-event.fc-event-start.fc-event-end.fc-event-past.gray {
  display: none;
}
.custome-gray {
  left: 0 !important;
  right: 0 !important;
}
</style>
<style>
.confhub .time-button {
  border: 1px solid rgba(0, 162, 255, 0.5);
  width: 95%;
  height: 35px;
  color: rgb(0, 162, 255);
  background-color: white;
  cursor: pointer;
}

.confhub .time-button:focus,
.confhub .time-button:hover {
  border: 2px solid rgba(0, 162, 255, 0.5);
}

.confhub .time-button.isActive {
  width: 95%;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  border-color: transparent;
}
.swal2-container {
  z-index: 99999 !important;
}
span.confereceType {
  position: absolute;
  right: 2px;
}
.fc .fc-view-harness .fc-list-empty,
.fc-list {
  min-height: 500px !important;
}

.bg-light-blue {
  background: rgba(0, 207, 232, 0.12) !important;
  color: #00cfe8 !important;
  border: 1px solid rgba(0, 207, 232, 0.1);
}
.bg-light-orange {
  background: rgba(255, 159, 67, 0.12) !important;
  color: #ff9f43 !important;
  border: 1px solid rgba(255, 159, 67, 0.1);
}
.bg-light-red {
  background: rgba(234, 84, 85, 0.12) !important;
  color: #ea5455 !important;
  border: 1px solid rgba(234, 84, 85, 0.1);
}
.fc .fc-daygrid-event-harness .fc-event {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  margin-top: 0.3rem;
}
.fc .fc-timegrid-event-harness .fc-event {
  padding: 0.25rem 0.5rem !important;
}
.fc .fc-event .fc-event-main {
  color: inherit;
}
.fc .fc-timegrid-event-harness .fc-event {
  font-size: 0.8rem;
  font-weight: 600;
}
.fc .fc-timegrid .fc-timegrid-slots .fc-timegrid-slot {
  height: 3rem;
}
.fc-list-event.bg-light-orange,
.fc-list-event.bg-light-red,
.fc-list-event.bg-light-blue {
  background: none !important;
  color: #6e6b7b !important;
}
.bg-light-blue .fc-list-event-dot {
  border-color: #00cfe8 !important;
}
.bg-light-orange .fc-list-event-dot {
  border-color: #ff9f43 !important;
}
.bg-light-red .fc-list-event-dot {
  border-color: #ea5455 !important;
}
.bg-light-blue.fc-list-event:hover td {
  background: rgba(0, 207, 232, 0.1) !important;
}
.bg-light-orange.fc-list-event:hover td {
  background: rgba(255, 159, 67, 0.1) !important;
}
.bg-light-red.fc-list-event:hover td {
  background: rgba(234, 84, 85, 0.1) !important;
}
.fc .fc-list .fc-list-day-cushion {
  background: #f8f8f8;
}
.fc-list-day-text,
.fc-list-day-side-text,
.fc-list-day-text:hover,
.fc-list-day-side-text:hover {
  color: inherit;
  font-size: 14px;
}
.fc .fc-list-day-cushion,
[dir] .fc .fc-list-table td {
  padding: 8px 14px;
}

.fc .fc-daygrid-day-number,
.fc .fc-list-event-time,
.fc .fc-timegrid-slot-label-cushion {
  color: #6e6b7b;
}
.fc-daygrid-body .fc-day-future .fc-daygrid-day-number,
.fc-daygrid-body .fc-day-past .fc-daygrid-day-number {
  color: #b9b9c3;
}
.fc .fc-col-header-cell-cushion {
  padding: 2px 4px;
  font-size: 14px;
}
.fc tbody td.fc-col-header-cell,
.fc thead th.fc-col-header-cell,
.fc tbody td.fc-col-header-cell,
.fc thead th.fc-col-header-cell {
  border-right: 0;
  border-left: 0;
}
.fc
  .fc-timegrid
  .fc-timegrid-axis.fc-scrollgrid-shrink
  .fc-timegrid-axis-cushion {
  text-transform: capitalize;
  color: #b9b9c3;
}
.fc .fc-timegrid-axis-cushion,
.fc .fc-timegrid-slot-label-cushion {
  padding: 0 4px;
}
.fc table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em;
}
.fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,
.fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis,
.fc .fc-timegrid .fc-scrollgrid-section .fc-col-header-cell,
.fc .fc-timegrid .fc-scrollgrid-section .fc-timegrid-axis {
  border-left: 0;
  border-right: 0;
}
.fc-timegrid-slot-label-cushion.fc-scrollgrid-shrink-cushion {
  text-transform: uppercase;
}
.fc tbody td,
.fc thead th {
  border-color: #ebe9f1;
}
.fc-col-header-cell-cushion {
  color: #6e6b7b !important;
}
.fc-direction-ltr .fc-timegrid-slot-label-frame {
  text-align: center;
}
.fc .fc-scrollgrid {
  border-collapse: separate;
}
.fc .fc-timegrid .fc-timegrid-divider {
  display: none;
}
tr.fc-list-event.fc-event.fc-event-start.fc-event-end.fc-event-today.fc-event-future.gray {
  display: none;
}
.custom-calendar-button {
  padding: 0.55rem 1.5rem;
}
.c-bg-primary,
.btn-outline-primary:hover {
  background-color: rgba(115, 103, 240, 0.2) !important;
  border-color: #7367f0 !important;
  color: #7367f0 !important;
}
.fc .fc-daygrid-day-top {
  flex-direction: row;
}
.fc-dayGridMonth-view .fc-highlight {
  background: transparent;
}
span.mx-3.text-xl.font-medium.whitespace-no-wrap {
  font-size: 1.45rem !important;
}
.fc-theme-standard .fc-popover-header {
  background: #fff;
  padding: 0.5rem;
}
.fc-list-event-dot {
  display: none !important;
}
.bg-white {
  background-color: #fff;
}
#accept {
  display: contents;
}

@media (max-width: 575px) {
  .calendar-type-list {
    text-align: center !important;
  }
  .custom-calendar-button {
    padding: 10px;
  }
  .mobile-flex {
    display: unset !important;
    text-align: center !important;
  }
  .mobile-item-center {
    display: unset !important;
  }
  .fc-list-event-time {
    min-width: 75px !important;
    width: auto !important;
    white-space: break-spaces !important;
  }
  .fc .fc-list-event-graphic,
  .fc .fc-list-event-time {
    white-space: break-spaces;
  }
  .fc-list-event-graphic {
    padding: 0px !important;
  }
  .fc-list-event-time,
  .fc-list-event-title {
    padding: 8px 10px !important;
  }
}
@media (max-width: 767px) {
  .custom-calendar-button {
    padding: 10px;
  }
  .mobile-flex {
    text-align: left;
  }
}
a.fc-col-header-cell-cushion {
  padding: 2px !important;
  font-size: 10px !important;
}
.heading span#export {
  top: 5px;
}

.fc-timegrid-now-indicator-line {
  border-color: blue !important;
}
.fc-timegrid-now-indicator-arrow {
  border-color: var(--fc-now-indicator-color, blue) !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}
#appointment_sidebar {
  padding-top: 0px !important;
}
.appointment-of {
  width: 22em;
}
.text-blue {
  color: #7961f9;
}
#workshift-link {
  color: #007bff !important;
}
#start_time1 #end_time1 .flatpickr-input {
  width: 100% !important;
}
.image-right {
  float: right;
}
@media (max-width: 900px) {
  .image-right {
    float: left;
  }
}
@media (min-width: 899px) {
  .image-right {
    float: right;
    margin-right: 40px;
  }
  .image-pos {
    position: absolute;
    right: 0;
    bottom: 30%;
  }
}
.flex-rev {
  display: flex;
  flex-direction: row-reverse;
}
</style>
